import React, { useCallback, useEffect, useLayoutEffect, useRef, useState, } from "react";
import { Accordion, Container, InputGroup, Modal, Overlay, Tooltip, } from "react-bootstrap";
import homeImage from "../../assets/images/home.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { commonservices, TIMEZONE_LIST } from "../../services/CommonServices";
import { useDispatch, useSelector } from "react-redux";
import workflowSetting from "../../assets/images/workflowSetting.svg";
import supportmodule from "../../assets/images/supportmodule.svg";
import closeImage from "../../assets/images/close-white.svg";
import searchicon from "../../assets/images/searchicon.svg";
import pinned from "../../assets/images/Pinned.svg";
import unpinned from "../../assets/images/Unpin.svg";
import Loader, { LoaderType } from "../common-component/Loader";
import DemoLogo from "../../assets/images/quantummain.svg";
import notmachineavaliable from "../../assets/images/notmachineavaliable.png";
import buymoremachine from "../../assets/images/buymoremachine.svg";
import Form from "react-bootstrap/Form";
import WorkFlowStatusModel from "../../Modals/WorkFlowStatusModel";
import WorkflowCostSummaryModel from "../../Modals/WorkflowCostSummaryModel";
import ReactFlow, { addEdge, Background, Controls, MiniMap, useEdgesState, useNodesState, } from "react-flow-renderer";
import dagre from "dagre";
import WorkFlowMachineSetupModel from "../../Modals/WorkFlowMachineSetupModel";
import blackrightupicon from "../../assets/images/blackrightupicon.svg";
import charticon from "../../assets/images/charticon.svg";
import toprightgreen from "../../assets/images/toprightgreen.svg";
import dounlefticon from "../../assets/images/dounlefticon.svg";
import actionLog from "../../assets/images/actionLog.svg";
import moment from "moment";
import {
    GetSandboxWorkFlowByID,
    setSandboxGetWorkFlowByID,
    SandboxWorkFlowSave,
} from "../../services/ReduxTookit/Slice/SandboxWorkFlowRedux";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { MyMachineGetList } from "../../services/ReduxTookit/Slice/MachineRedux";
import SupportModel from "./FlowNewModels/SupportModel";
import ManageStatusBar from "../../Modals/ManageStatusBar";
import ManageStatusBarBlank from "../../Modals/ManageStatusBarBlank";
import MainpageLoader from "../common-component/Loaders/MainpageLoader";
import CounterPage from "./CounterPage";
import { ProjectTermGetList } from "../../services/ReduxTookit/Slice/ProjectTermRedux";
import DataMapping from "./DataMapping";
import ButtonEdge from "./ButtonEdge";
import workflow_invalid from "../../assets/images/workflow_invalid.svg";
import workflow_suspend from "../../assets/images/workflow_suspend.svg";
import workflow_active from "../../assets/images/workflow_active.svg";
import playicon from "../../assets/images/FlowButtonSVG/play.svg";
import playblackicon from "../../assets/images/playblackicon.svg";
import configmodule from "../../assets/images/configmodule.svg";
import Json from "../../assets/images/json.svg";
import logdata from "../../assets/images/log-data.svg";
import MachineOutputView from "./MachineOutputView";
import SandboxWorkFlowMachineLogDetailModal from "../common-component/SandboxWorkFlowMachineLogDetailModal";
import ConfigModel from "./FlowNewModels/ConfigModel";
import { Dropdown } from "react-bootstrap";
import { WorkflowGetListForDDL } from "../../services/ReduxTookit/Slice/WorkFlowRedux";
import { API_URL } from "../../services/APIRoute";
export function CalculateMachineDurationSec({ Seconds }) {
    if (Seconds) {
        if (Seconds <= 60) {
            return (
                <p>
                    <span>{String(Seconds).padStart(2, "0")}</span>s
                </p>
            );
        } else if (Seconds < 3600) {
            const minutes = Math.floor(Seconds / 60);
            const seconds = Seconds % 60;
            return (
                <p>
                    <span>{String(minutes).padStart(2, "0")}</span>m
                    <span> {String(seconds).padStart(2, "0")}</span>s
                </p>
            );
        } else {
            const hours = Math.floor(Seconds / 3600);
            const minutes = Math.floor((Seconds % 3600) / 60);
            const seconds = Seconds % 60;
            return (
                <p>
                    <span>{String(hours).padStart(2, "0")}</span>h
                    <span> {String(minutes).padStart(2, "0")}</span>m
                </p>
            );
        }
    } else {
        return (
            <p>
                <span>{"00"}</span>s
            </p>
        );
    }
}

export const CalculateMachineDurationSecInOtherFormat = ({ Seconds }) => {
    if (Seconds) {
        if (Seconds <= 60) {
            return (
                <p>
                    <span>00:{String(Seconds).padStart(2, "0")}</span>
                </p>
            );
        } else if (Seconds < 3600) {
            const minutes = Math.floor(Seconds / 60);
            const seconds = Seconds % 60;
            return (
                <p>
                    <span>{String(minutes).padStart(2, "0")}</span>:
                    <span> {String(seconds).padStart(2, "0")}</span>
                </p>
            );
        } else {
            const hours = Math.floor(Seconds / 3600);
            const minutes = Math.floor((Seconds % 3600) / 60);
            const seconds = Seconds % 60;

            return (
                <p>
                    <span>{String(hours).padStart(2, "0")}</span>:
                    <span>{String(minutes).padStart(2, "0")}</span>
                </p>
            );
        }
    } else {
        return (
            <p>
                <span>{"00:00"}</span>
            </p>
        );
    }
};

export const CalculateWorkflowDurationSecInOtherFormat = ({ Seconds }) => {
    if (Seconds) {
        if (Seconds <= 60) {
            return <>00:{String(Seconds).padStart(2, "0")}</>;
        } else if (Seconds < 3600) {
            const minutes = Math.floor(Seconds / 60);
            const seconds = Seconds % 60;
            return (
                <>
                    {String(minutes).padStart(2, "0")}:{String(seconds).padStart(2, "0")}
                </>
            );
        } else {
            const hours = Math.floor(Seconds / 3600);
            const minutes = Math.floor((Seconds % 3600) / 60);
            const seconds = Seconds % 60;

            return (
                <>
                    {String(hours).padStart(2, "0")}:{String(minutes).padStart(2, "0")}
                </>
            );
        }
    } else {
        return <>{"00:00"}</>;
    }
};

const Sandbox = () => {
    const nodeWidth = 300;
    const nodeHeight = 180;
    const LOOP_NODE_SHORT_NAMES = ["loopstart-0-0-0", "loopend-0-0-0"];

    const getNodeIdsToRemove = (nodeId, nodeList) => {
        const selectedNode = nodeList.find((node) => node.id === nodeId);

        if (!selectedNode) {
            return [nodeId];
        }

        if (!LOOP_NODE_SHORT_NAMES.includes(selectedNode.shortName)) {
            return [nodeId];
        }

        return nodeList
            .filter((node) => LOOP_NODE_SHORT_NAMES.includes(node.shortName))
            .map((node) => node.id);
    };

    function CalculateNodePositionAndWidthHeight(event, assemblyname) {
        let x = 0,
            y = 0;
        let w = nodeWidth,
            h = nodeHeight,
            s = 1;

        // Get node width and height if any node is selected
        const _node = document.querySelector(".react-flow__node.selectable");
        if (_node) {
            const rect = _node.getBoundingClientRect();
            w = rect.width;
            h = rect.height;

            if (
                assemblyname === "loopstart-0-0-0" ||
                assemblyname === "loopend-0-0-0"
            ) {
                h = h / 2;
            }
        }

        if (event) {
            // Get left panel width safely
            let leftPanelWidth =
                document.querySelector(".left-panel")?.clientWidth || 0;
            let topPanelHeight =
                document.querySelector(".flow-chart-container")?.clientHeight || 0;

            // Get viewport transformations
            let viewportPosition = { x: 0, y: 0, s: 1 };
            const reactFlowWrapper = document.getElementById(
                "canvas-workflow-wrapper-ReactFlow"
            );
            if (reactFlowWrapper) {
                const viewport = reactFlowWrapper.querySelector(
                    ".react-flow__viewport"
                );
                if (viewport) {
                    const style = window.getComputedStyle(viewport);
                    if (style.transform !== "none") {
                        const matrix = new DOMMatrixReadOnly(style.transform);
                        viewportPosition.x = matrix.m41;
                        viewportPosition.y = matrix.m42;
                        viewportPosition.s = matrix.m11; // Scale factor
                    }
                }
            }

            s = viewportPosition.s;
            // Adjust position with scaling correction
            x = (event.clientX - leftPanelWidth - viewportPosition.x) / s - w / 2;
            y = (event.clientY - topPanelHeight - viewportPosition.y) / s - h / 2;
        }

        return { x, y, w, h, s };
    }

    let EncID = useParams();

    const edgeTypes = {
        custom: ButtonEdge,
    };

    let Edgetype = "custom";
    let Defaultedgetype = "bezier";
    let Userdata = useSelector((state) => state.userinfo.UserInfo);
    const id = commonservices.bodyDecryption(EncID?.id)?.split("?")[0];
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();
    const divRef = useRef(null); // Ref for the div
    const GetWorkFlowIDData = useSelector(
        (state) => state?.sandboxworkflowredux?.SandboxGetWorkFlowByIDData?.data
    );
    const [nodes, setNodes, onNodesChange] = useNodesState([]);

    const [machineDataLoading, setMachineDataLoading] = useState(false);
    const [selectedNode, setSelectedNode] = useState(null);
    const [edges, setEdges, onEdgesChange] = useEdgesState([]);
    const [WorkFlowStatus, setWorkFlowStatus] = useState([]);

    const [ProjectTermList, setProjectTermList] = useState({
        CPU: [],
        RAM: [],
    });
    const [getWorkflowPopup, setWorkflowPopup] = useState(false);

    const FnForSetNodes = (data) => {
        setNodes(data);
    };

    const [NetworkUsageChart, setNetworkUsageChart] = useState({
        labels: [],
        datasets: [],
    });

    const [NewMachineInfo, setNewMachineInfo] = useState({
        name: "",
        ID: "",
        desc: "",
    });


    const [allMachineList, setAllMachineList] = useState(null);

    const [flowDetails, setFlowDetails] = useState("");

    const [supportShowModel, setSupportShowModel] = useState(false);

    const [FlowLoader, setFlowLoader] = useState(false);

    const [trackState, setTrackState] = useState(false);

    const [MemoryUsageChart, setMemoryUsageChart] = useState({
        labels: [],
        datasets: [],
    });

    const [CPUUsageChart, setCPUUsageChart] = useState({
        labels: [],
        datasets: [],
    });

    const [IsWorkFlowIsRunning, setIsWorkFlowIsRunning] = useState(false);

    const [connection, setConnection] = useState(null);

    const [flowName, setFlowName] = useState("sandbox-" + Date.now());

    const [parallelism, setParallelism] = useState(2);
    const [retrystrategy, setRetrystrategy] = useState(3);
    const [parametersforworkflow, setParametersForWorkflow] = useState([]);
    const [loop_sample_data, setLoop_sample_data] = useState([]);
    const [eksnodegroup, setEksnodegroup] = useState("");
    const [WorkFlowMachineStatus, setWorkFlowMachineStatus] = useState([]);


    const [machineList, setMachineList] = useState(null);

    const [activeSidePanel, setActiveSidePanel] = useState(false);

    const [activeSidePanelPinned, setActiveSidePanelPinned] = useState(false);


    const [WorkFlowMachineUse, setWorkFlowMachineUse] = useState([]);

    const [activeTab, setActiveTab] = useState(0);

    const [allMachineDetails, setAllMachineDetails] = useState();

    const [searchInput, setSearchInput] = useState("");

    const [connectingNode, setConnectingNode] = useState(null);

    const [hoveredNode, setHoveredNode] = useState(null);

    const [activeRightSidePanel, setActiveRightSidePanel] = useState("sm-panel");

    const [activeRightSidePinnedPanel, setActiveRightSidePinnedPanel] =
        useState("sm-panel");

    const FnForsetActiveRightSidePanel = (data) => {
        setTimeout(() => {
            setActiveRightSidePanel(data);
        }, 120);
    };

    const GetSecondCounts = (startTime, endTime) => {
        // If endTime is missing, use current time
        if (!endTime) {
            endTime = new Date();
        }

        // Parse a timestamp (string or Date object)
        const parseTimestamp = (timestamp) => {
            if (!timestamp) return null;

            // If it's a Date object
            if (timestamp instanceof Date) {
                return {
                    hours: timestamp.getHours(),
                    minutes: timestamp.getMinutes(),
                    seconds: timestamp.getSeconds(),
                };
            }

            // If it's a string e.g. "2025-11-17T12:34:56"
            if (typeof timestamp === "string" && timestamp.includes("T")) {
                const [datePart, timePart] = timestamp.split("T");
                if (!timePart) return null;

                const [hh = "0", mm = "0", ss = "0"] = timePart.split(":");

                return {
                    hours: parseInt(hh, 10) || 0,
                    minutes: parseInt(mm, 10) || 0,
                    seconds: parseInt(ss, 10) || 0,
                };
            }

            return null;
        };

        const start = parseTimestamp(startTime);
        const end = parseTimestamp(endTime);

        if (!start || !end) {
            return 0;
        }

        const startTotalSeconds =
            start.hours * 3600 + start.minutes * 60 + start.seconds;
        const endTotalSeconds =
            end.hours * 3600 + end.minutes * 60 + end.seconds;

        return endTotalSeconds - startTotalSeconds;
    };

    async function getProjectTermList() {
        dispatch(ProjectTermGetList({}))?.then((response) => {
            if (response?.payload?.isValidate) {
                if (response?.payload?.data?.data?.length > 0) {
                    let cloudarray = [];
                    response?.payload?.data?.data.forEach((element) => {
                        if (element?.category === "Cloud") {
                            cloudarray.push({
                                value: element?.term,
                                label: element?.term,
                            });
                        }
                    });
                    setProjectTermList({
                        CPU: response?.payload?.data?.data.filter(
                            (f) => f.category === "CPU"
                        ),
                        RAM: response?.payload?.data?.data.filter(
                            (f) => f.category === "RAM"
                        ),
                    });
                }
            }
            if (!response?.payload?.isValidate) {
            }
        });
    }

    const GetPersentageCount = ({ lastweek, thisweek }) => {
        let Caluculation = commonservices?.CalculateUseInPersentage(
            parseInt(lastweek || 0),
            parseInt(thisweek || 0)
        );
        return (
            <div className="datamonthinner-span">
                {isNaN(Caluculation) ? (
                    <>
                        <span className="nan-error">{"--"}</span>
                    </>
                ) : (
                    <>
                        {Caluculation > 0 ? (
                            <>
                                {" "}
                                <span style={{ color: "#E00" }}>{Caluculation + "%"}</span>
                                <img src={dounlefticon} alt="dounlefticon" />
                            </>
                        ) : (
                            <>
                                {" "}
                                <span>{Math.abs(Caluculation) + "%"}</span>
                                <img src={toprightgreen} alt="toprightgreen" />
                            </>
                        )}
                    </>
                )}
            </div>
        );
    };

    const CreateModel = (
        image,
        id,
        name,
        shortName,
        WorkFlowIsRunning,
        sameMachineNo,
        statusdata,
        extra,
        flowDetails
    ) => {
        let WorkflowMachineDetailsImg = workflow_invalid;
        let M = allMachineDetails?.filter((m) =>
            shortName.includes(m.assemblyname)
        );

        if (M && M.length > 0) {
            image = M[0].machinelogo;
        }

        let WorkFlowIsRunningData = WorkFlowIsRunning;

        const ExtraData = statusdata?.filter(
            (item) =>
                item.workflowmachinename?.toUpperCase() === shortName?.toUpperCase()
        );


        if (shortName === "loopstart-0-0-0" || shortName === "loopend-0-0-0") {
            return (
                <div className={`node-content main-machine-startercard`}>
                    <div className="machine-startercard">
                        {shortName === "loopstart-0-0-0" && (
                            <button
                                title="Loop Start"
                                className="loop-start-icon loop-btn"
                            >
                                <svg
                                    width="49"
                                    height="44"
                                    viewBox="0 0 49 44"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M5.10929 9.24383C15.8273 -5.42664 38.8968 -0.621485 43.1919 16.7105L45.7658 11.7779C45.9635 11.4038 46.3016 11.1236 46.7058 10.9988C47.1101 10.874 47.5473 10.9149 47.9214 11.1125C48.2955 11.3101 48.5757 11.6482 48.7005 12.0525C48.8253 12.4567 48.7844 12.894 48.5868 13.268L43.6302 22.6632C43.4645 22.9706 43.2025 23.2151 42.8843 23.3591C42.5661 23.5031 42.2094 23.5386 41.8691 23.4601C41.7334 23.4206 41.6004 23.3727 41.4707 23.3166L32.0357 18.376C31.6606 18.1731 31.3814 17.8295 31.2596 17.4208C31.1378 17.0121 31.1833 16.5717 31.3862 16.1966C31.5891 15.8214 31.9327 15.5423 32.3415 15.4205C32.7502 15.2987 33.1906 15.3442 33.5657 15.5471L40.4188 19.1649C38.0282 3.2832 17.3094 -1.98414 7.68319 11.1245C-1.17009 22.9341 7.61147 40.2821 22.3855 40.1546C26.2684 40.1622 30.0509 38.9219 33.1752 36.6165C33.3431 36.4849 33.5358 36.3883 33.7417 36.3325C33.9477 36.2767 34.1627 36.2629 34.3741 36.2917C34.5855 36.3206 34.7889 36.3916 34.9724 36.5006C35.1558 36.6096 35.3155 36.7543 35.442 36.9261C35.5685 37.0979 35.6591 37.2934 35.7087 37.5009C35.7582 37.7085 35.7655 37.9238 35.7302 38.1343C35.695 38.3447 35.6178 38.5459 35.5033 38.7259C35.3889 38.906 35.2394 39.0612 35.0638 39.1824C31.3952 41.8966 26.949 43.3554 22.3855 43.3421C5.0296 43.4935 -5.28993 23.1174 5.10929 9.24383Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </button>
                        )}
                        {shortName === "loopend-0-0-0" && (
                            <button title="Loop End" className="loop-end-icon loop-btn">
                                <svg
                                    width="49"
                                    height="43"
                                    viewBox="0 0 49 43"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M44.3106 34.1785C33.5927 48.849 10.5231 44.0438 6.22798 26.7118L3.65408 31.6445C3.45647 32.0186 3.11835 32.2988 2.71411 32.4236C2.30987 32.5484 1.87261 32.5075 1.49853 32.3099C1.12445 32.1123 0.844192 31.7741 0.719407 31.3699C0.594622 30.9657 0.635533 30.5284 0.83314 30.1543L5.7897 20.7592C5.95539 20.4517 6.21747 20.2072 6.53565 20.0633C6.85383 19.9193 7.21049 19.8838 7.5508 19.9623C7.68648 20.0017 7.81955 20.0496 7.94923 20.1057L17.3842 25.0463C17.7594 25.2492 18.0385 25.5928 18.1603 26.0016C18.2821 26.4103 18.2366 26.8507 18.0337 27.2258C17.8308 27.6009 17.4872 27.8801 17.0785 28.0019C16.6697 28.1237 16.2294 28.0781 15.8542 27.8753L9.00111 24.2574C11.3917 40.1392 32.1105 45.4065 41.7367 32.2979C50.59 20.4882 41.8084 3.14025 27.0344 3.26775C23.1516 3.26016 19.3691 4.50051 16.2447 6.80588C16.0768 6.9375 15.8841 7.03407 15.6782 7.08986C15.4723 7.14564 15.2572 7.15951 15.0458 7.13063C14.8344 7.10176 14.631 7.03073 14.4475 6.92177C14.2641 6.8128 14.1044 6.66811 13.9779 6.49628C13.8515 6.32444 13.7608 6.12896 13.7113 5.92143C13.6617 5.71389 13.6544 5.49853 13.6897 5.2881C13.7249 5.07768 13.8021 4.87648 13.9166 4.69643C14.0311 4.51638 14.1805 4.36115 14.3561 4.23994C18.0247 1.52573 22.4709 0.0669731 27.0344 0.0802528C44.3903 -0.0711534 54.7099 20.3049 44.3106 34.1785Z"
                                        fill="currentColor"
                                    />
                                    <rect
                                        x="23.0137"
                                        y="13.7715"
                                        width="3.45568"
                                        height="15.4545"
                                        rx="1.72784"
                                        fill="currentColor"
                                    />
                                    <rect
                                        x="29.4883"
                                        y="13.7715"
                                        width="3.45568"
                                        height="15.4545"
                                        rx="1.72784"
                                        fill="currentColor"
                                    />
                                </svg>
                            </button>
                        )}

                        <button
                            title="Close"
                            className="close-button"
                            onClick={(e) => {
                                e.stopPropagation();
                                if (
                                    shortName === "loopend-0-0-0" ||
                                    shortName === "loopstart-0-0-0"
                                ) {
                                    handleRemoveNode(id);
                                } else {
                                    handleRemoveNode(id);
                                }
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="7"
                                height="7"
                                viewBox="0 0 7 7"
                                fill="none"
                            >
                                <path
                                    d="M0.796898 1.04297L5.53253 5.77861M5.5325 1.04297L0.796875 5.77861"
                                    stroke="currentColor"
                                    stroke-width="1.57855"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            )
        }
        else if (shortName.toUpperCase().indexOf("QD#SYSTEM#SUBWORKFLOW-") >= 0) {
            if (M?.[0]?.versionnumber === "Active") {
                WorkflowMachineDetailsImg = workflow_active;
            }
            else if (M?.[0]?.versionnumber === "Suspend") {
                WorkflowMachineDetailsImg = workflow_suspend;
            }

            return (
                <div className={`node-content subworkflow-container newflow-node-content ${M?.[0]?.versionnumber ? M?.[0]?.versionnumber : ""}`}>
                    <div className={`subworkflow-title ${M?.[0]?.versionnumber ? M?.[0]?.versionnumber : ""}`}>
                        <img
                            className="subworkflow-img"
                            src={image || DemoLogo}
                            alt={name}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = DemoLogo;
                            }}
                        />
                        {commonservices.truncateText(name, 30)}{" "} {sameMachineNo !== 0 ? "-" + sameMachineNo : ""}

                        <button
                            title="Close"
                            className="close-button"
                            onClick={(e) => {
                                e.stopPropagation();
                                if (
                                    shortName === "loopend-0-0-0" ||
                                    shortName === "loopstart-0-0-0"
                                ) {
                                    handleRemoveNode(id);
                                } else {
                                    handleRemoveNode(id);
                                }
                            }}
                        >
                            <svg
                                fill="#111111"
                                width="20px"
                                height="20px"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z" />
                            </svg>
                        </button>
                    </div>
                    <div className={`subworkflow-details`}>
                        <img src={WorkflowMachineDetailsImg} alt="Workflow" />
                    </div>
                </div>
            )
        }
        else {
            return (
                <div className={`node-content newflow-node-content`}>
                    <div className={`flownew-detail-title`}>
                        <span className="mt-0">
                            <h4 title={name + (sameMachineNo !== 0 ? "-" + sameMachineNo : "")}>
                                {commonservices.truncateText(name, 30)}{" "}{sameMachineNo !== 0 ? "-" + sameMachineNo : ""}
                            </h4>
                        </span>
                    </div>
                    <div className="flowcard-detail-block">
                        <div className="flowcard-versionplay">
                            <img
                                src={image || DemoLogo}
                                alt={name}
                                onError={(e) => {
                                    e.target.onerror = null; // Prevents infinite loop in case fallback also fails
                                    e.target.src = DemoLogo;
                                }}
                            />
                            <span className=" versionmachine mt-1">
                                {M?.[0]?.versionnumber ? M?.[0]?.versionnumber : ""}
                            </span>
                        </div>
                        <div className="flowcard-detail">
                            <span>Details</span>
                            <img
                                className="cursor-pointer"
                                src={blackrightupicon}
                                alt="blackrightupicon"
                                onClick={() => FnForsetActiveRightSidePanel("machine")}
                            />
                            <img
                                className="cursor-pointer"
                                src={charticon}
                                alt="charticon"
                                onClick={() => FnForsetActiveRightSidePanel("summary")}
                            />
                        </div>
                    </div>
                    <div
                        className=" d-flex align-items-center gap-1"
                        style={{ width: "100%" }}
                    >
                        <div style={{ width: "100%" }}>
                            {ExtraData.length > 0 && parseInt(ExtraData[0]?.stepno) ? (
                                <ManageStatusBar
                                    step={parseInt(ExtraData[0]?.stepno)}
                                    status={ExtraData[0]?.status}
                                />
                            ) : (
                                <ManageStatusBarBlank />
                            )}
                        </div>
                        {WorkFlowIsRunningData && (
                            <div className="progress-second">
                                <span>
                                    {ExtraData[0]?.starton &&
                                        ExtraData[0]?.endon &&
                                        (ExtraData[0]?.status === "end" ||
                                            ExtraData[0]?.status === "fail") ? (
                                        <CalculateMachineDurationSecInOtherFormat
                                            Seconds={GetSecondCounts(
                                                ExtraData[0]?.starton,
                                                null
                                            )}
                                        />
                                    ) : (
                                        <>
                                            {ExtraData[0]?.starton && (
                                                <CounterPage
                                                    start={ExtraData[0]?.starton}
                                                    type="sub"
                                                />
                                            )}
                                        </>
                                    )}
                                </span>
                            </div>
                        )}
                    </div>

                    {WorkFlowIsRunningData ? (
                        <>
                            {ExtraData[0]?.status.toLowerCase() === "start" ? (
                                <div className="datashow-machine-main">
                                    <div className="Preprocessing-flow">
                                        <p>
                                            {ExtraData[0]?.starton &&
                                                commonservices.convertTimeToLocal(
                                                    WorkFlowStatus[0]?.starton
                                                )}{" "}
                                            {ExtraData[0]?.logdata
                                                ?.substring(
                                                    ExtraData[0]?.logdata?.lastIndexOf("\n") + 1,
                                                    ExtraData[0]?.logdata?.length
                                                )
                                                .trim()}
                                        </p>
                                        <img
                                            className="cursor-pointer"
                                            src={actionLog}
                                            alt="actionLog"
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className="datashow-machine-main">
                                    {ExtraData[0]?.noofrun ? (
                                        <div className="success-ratio-block">
                                            <h4>Success Ratio</h4>
                                            <p>
                                                {parseInt(ExtraData[0]?.noofsuccess)}/
                                                {parseInt(ExtraData[0]?.noofrun)}{" "}
                                                <span className="seccess-doticon"></span>{" "}
                                                <span>
                                                    {(
                                                        (parseInt(ExtraData[0]?.noofsuccess) * 100) /
                                                        parseInt(ExtraData[0]?.noofrun)
                                                    ).toFixed(2)}
                                                    %
                                                </span>
                                            </p>
                                        </div>
                                    ) : (
                                        <div className="success-ratio-block"></div>
                                    )}

                                    <div>
                                        {!ExtraData[0]?.status ? (
                                            <button className="yellow-badge mt-2">To Do</button>
                                        ) : (
                                            <></>
                                        )}
                                        {ExtraData[0]?.status.toLowerCase() === "failed" ? (
                                            <button className="red-badge mt-2">Fail</button>
                                        ) : (
                                            <></>
                                        )}
                                        {ExtraData[0]?.status.toLowerCase() === "end" ? (
                                            <button className="green-badge-flow mt-2">
                                                Success
                                            </button>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="datashow-machine-main">
                            <div className="datamonthly sandbox-node-action-button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (ExtraData.length > 0 && ExtraData[0].machineulogid) {
                                        setMachineLogPopupData({
                                            IsOpen: true,
                                            MachineULogID: ExtraData[0].machineulogid
                                        })
                                    }
                                }}>
                                <img
                                    src={logdata}
                                    alt="View Log"
                                />
                                <p className="title">Log</p>
                            </div>
                            {
                                shortName.toLowerCase() !== "starter" &&
                                <>
                                    <div className="datamonthly sandbox-node-action-button" onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (ExtraData.length > 0 && ExtraData[0].outputdata) {
                                            setMachineOutputPopupData({
                                                IsOpen: true,
                                                JsonData: JSON.stringify(JSON.parse(ExtraData[0].outputdata), null, 2),
                                                MachineName: name + (sameMachineNo !== 0 ? "-" + sameMachineNo : "")
                                            })
                                        }
                                    }}>
                                        <img
                                            src={Json}
                                            alt="View Output"
                                        />
                                        <p className="title">Output</p>
                                    </div>
                                    <div className="datamonthly sandbox-node-action-button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleWorkFlowSaveRef.current?.("SAVE AND RUN", shortName); }}>
                                        <img
                                            src={playblackicon}
                                            alt="Run Now"
                                        />
                                        <p className="title">Run</p>
                                    </div>
                                </>
                            }

                        </div>
                    )}
                    {shortName === "Starter" ? (
                        <></>
                    ) : (
                        <button
                            title="Close"
                            className="close-button"
                            onClick={(e) => {
                                e.stopPropagation();
                                if (
                                    shortName === "loopend-0-0-0" ||
                                    shortName === "loopstart-0-0-0"
                                ) {
                                    handleRemoveNode(id);
                                } else {
                                    handleRemoveNode(id);
                                }
                            }}
                        >
                            <svg
                                fill="#111111"
                                width="20px"
                                height="20px"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z" />
                            </svg>
                        </button>
                    )}
                </div>
            )
        }
    };




    useEffect(() => {
        if (!nodes) return;

        let updatedNodes = nodes.map((node) =>
            node.typeName === "Starter" && node.ram === "" && node.cpu === ""
                ? { ...node, ram: "256Mi", cpu: "500m" }
                : node
        );

        if (JSON.stringify(updatedNodes) !== JSON.stringify(nodes)) {
            setNodes(updatedNodes);
        }
    }, [nodes]);


    const handleEdgeMouseEnter = (event, edge) => {
        setConnectingNode(edge.source);
    };

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };

    const handleEdgeMouseLeave = () => {
        setConnectingNode(null);
    };

    const onDragOver = useCallback((event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = "move";
        setTrackState(true);
    }, []);

    const onConnectStart = (event, { nodeId }) => {
        setConnectingNode(nodeId);
    };

    const handleNodeMouseLeave = () => {
        setHoveredNode(null);
    };

    const onConnectEnd = (event) => {

        if (connectingNode && hoveredNode && connectingNode !== hoveredNode.id) {
            let connectingNodeData = nodes.find((n) => n.id === connectingNode);
            if (connectingNodeData) {

                if (connectingNodeData.shortName.toUpperCase().indexOf("QD#SYSTEM#SUBWORKFLOW-") < 0) {
                    const newEdge = {
                        id: `${GenerateGUID()}`,
                        source_machineid: `${connectingNodeData.typeid}`,
                        source_machinename: `${connectingNodeData.typeName}`,
                        source_image: `${connectingNodeData.dockerimagename}`,
                        source_shortname: `${connectingNodeData.shortName}`,
                        source: connectingNode,
                        target: hoveredNode.id,
                        target_machineid: `${hoveredNode.typeid}`,
                        target_machinename: `${hoveredNode.typeName}`,
                        target_image: `${hoveredNode.dockerimagename}`,
                        target_shortname: `${hoveredNode.shortName}`,
                        type: hoveredNode.shortName !== "loopend-0-0-0" && hoveredNode.shortName !== "loopstart-0-0-0" ? Edgetype : Defaultedgetype,
                    };

                    // Check if edge already exists
                    const edgeExists = edges.some(
                        (edge) =>
                            edge.source === newEdge.source && edge.target === newEdge.target
                    );

                    if (!edgeExists) {
                        setEdges((prevEdges) => [...prevEdges, newEdge]);
                    }
                }
            }
        }
        setConnectingNode(null);
        setHoveredNode(null);
    };

    const handleNodeMouseEnter = (event, node) => {
        setHoveredNode(node);
    };

    function fnGetMachineLog(shortName, WFMData, WFMUData, IsWFIsRunning) {
        setMemoryUsageChart({
            labels: [],
            datasets: [],
        });
        setCPUUsageChart({
            labels: [],
            datasets: [],
        });
        setNetworkUsageChart({
            labels: [],
            datasets: [],
        });

        if (WFMData && WFMData?.length !== 0) {
            if (IsWFIsRunning) {
                setTimeout(() => {
                    setActiveRightSidePinnedPanel("summary");
                    setActiveRightSidePanel("summary");
                }, 100);
            } else {
                setTimeout(() => {
                    setActiveRightSidePanel("machine");
                }, 100);
            }
        }

        if (WFMUData && WFMUData?.length !== 0) {
            let data = WFMUData?.filter(
                (i) =>
                    i?.workflowmachinename?.toUpperCase() === shortName?.toUpperCase()
            );
            let memorylable = [];
            let memorydata = [];
            let cpulable = [];
            let cpudata = [];
            let networklable = [];
            let networkdata = [];
            if (data?.length > 0) {
                data?.forEach((element, index) => {
                    if (element["memory_usage_per"]) {
                        if (index === 0) {
                            memorylable.push(
                                moment.utc(element?.createdon).format("HH:mm:ss")
                            );
                            memorydata.push(0);
                        }
                        memorylable.push(moment.utc(element?.createdon).format("HH:mm:ss"));
                        memorydata.push(
                            element?.memory_usage_per !== "" ? element?.memory_usage_per : 0
                        );
                    }
                    if (element["cpu_usage"]) {
                        if (index === 0) {
                            cpulable.push(moment.utc(element?.createdon).format("HH:mm:ss"));
                            cpudata.push(0);
                        }
                        cpulable.push(moment.utc(element?.createdon).format("HH:mm:ss"));
                        cpudata.push(
                            element["cpu_usage"] !== "" ? element["cpu_usage"] : 0
                        );
                    }
                    if (
                        element["network_bytes_received_mb"] &&
                        element["network_bytes_sent_mb"]
                    ) {
                        let tempresult =
                            element["network_bytes_received_mb"] +
                            element["network_bytes_sent_mb"];
                        if (index === 0) {
                            networklable.push(
                                moment.utc(element?.createdon).format("HH:mm:ss")
                            );
                            networkdata.push(0);
                        }

                        networklable.push(
                            moment.utc(element?.createdon).format("HH:mm:ss")
                        );
                        networkdata.push(tempresult);
                    }
                });
            }

            setMemoryUsageChart({
                labels: memorylable,
                datasets: [
                    {
                        label: "Memory Usage",
                        data: memorydata,
                        borderColor: "#bc6cd4",
                        backgroundColor: "#bc6cd420",
                        borderWidth: 1.5,
                        fill: true,
                        tension: 0,
                    },
                ],
            });
            setCPUUsageChart({
                labels: cpulable,
                datasets: [
                    {
                        label: "CPU Usage",
                        data: cpudata,
                        borderColor: "#62b4e3",
                        backgroundColor: "#62b4e320",
                        borderWidth: 1,
                        fill: true,
                        tension: 0,
                    },
                ],
            });
            setNetworkUsageChart({
                labels: networklable,
                datasets: [
                    {
                        label: "Network Usage",
                        data: networkdata,
                        borderColor: "#d48e55",
                        backgroundColor: "#d48e5520",
                        borderWidth: 1,
                        fill: true,
                        tension: 0,
                    },
                ],
            });
        }
    }

    function BindWorkFlowAsMachine(dataFromApi) {

        let newDataList1 = (dataFromApi.dataList1 || []);

        let newDataList3 = (dataFromApi.dataList3 || []);

        let newDataList4 = (dataFromApi.dataList4 || []);

        if (id) {
            newDataList1 = newDataList1.filter(item => item.machineid !== (parseInt(id) * 10000));
            newDataList3 = newDataList3.filter(item => item.machineid !== (parseInt(id) * 10000));
        }

        dataFromApi = { ...dataFromApi, dataList1: newDataList1, dataList3: newDataList3, dataList4: newDataList4 };
        return dataFromApi;
    }

    const getMachineListBySubscriberId = async () => {
        setMachineDataLoading(true);
        dispatch(MyMachineGetList())?.then((response) => {
            setMachineDataLoading(false);
            if (response?.payload?.isValidate) {
                let groupingJson = {};
                let dataFromApi = response?.payload?.data?.data;
                dataFromApi = BindWorkFlowAsMachine(dataFromApi);

                setAllMachineDetails(dataFromApi?.dataList1);
                dataFromApi?.dataList4?.forEach((categoryItem) => {
                    let findMachineList = dataFromApi?.dataList1?.filter((x) => {
                        return (
                            x?.categoryid === categoryItem?.categoryid &&
                            x?.assemblyname !== "Starter" && x?.isdisplayinmenu === true
                        );
                    });

                    groupingJson = {
                        ...groupingJson,
                        [categoryItem?.categoryname]: findMachineList,
                    };
                });

                let StarterMachine = dataFromApi?.dataList1?.find(
                    (f) => f.machinename === "Starter"
                );

                if (StarterMachine && id?.toString() === "0") {
                    const position = {
                        x: 0,
                        y: 0,
                    };

                    const reactFlowWrapper = document.getElementById(
                        "canvas-workflow-wrapper-ReactFlow"
                    );
                    if (reactFlowWrapper) {
                        position.x = reactFlowWrapper.clientWidth / 2 - nodeWidth;
                    }

                    const id = GenerateGUID();
                    const typeid = StarterMachine?.machineid;
                    const typeName = StarterMachine?.machinename;
                    const image = StarterMachine?.machinelogo;
                    const dockerimagename = StarterMachine?.dockerimagename;
                    let shortName = StarterMachine?.assemblyname;
                    const template = StarterMachine?.assemblyname;
                    let sameMachineNo = 0;

                    let NoOfMachineExist = nodes.filter(
                        (x) => x.dockerimagename === dockerimagename
                    );
                    if (NoOfMachineExist !== null && NoOfMachineExist.length !== 0) {
                        NoOfMachineExist.sort((a, b) =>
                            a.sameMachineNo > b.sameMachineNo
                                ? 1
                                : b.sameMachineNo > a.sameMachineNo
                                    ? -1
                                    : 0
                        );

                        sameMachineNo =
                            NoOfMachineExist[NoOfMachineExist.length - 1].sameMachineNo + 1;
                        shortName = shortName + sameMachineNo;
                    }
                    const entrypointcommand = StarterMachine?.entrypointcommand;
                    const cpu = StarterMachine?.cpu || "500m";
                    const ram = StarterMachine?.ram || "256Mi";
                    const osrequirmet = StarterMachine?.osrequirmet;
                    const cloud = StarterMachine?.cloud;
                    const configList = allMachineList?.dataList2?.filter(
                        (x) => x?.machineid == StarterMachine?.machineid
                    );
                    const infoDetail = allMachineList?.dataList3?.filter(
                        (x) => x?.machineid == StarterMachine?.machineid
                    );
                    const PROXY_ENABLED = StarterMachine?.PROXY_ENABLED || false;
                    const PROXY_ROTATE_PER_REQUEST = StarterMachine?.PROXY_ROTATE_PER_REQUEST || true;
                    let outputdata = "";
                    const newNode = {
                        id,
                        typeid,
                        typeName,
                        position,
                        image,
                        dockerimagename,
                        shortName,
                        machine_version: StarterMachine?.versionnumber,
                        template: template,
                        sameMachineNo: sameMachineNo,
                        className: fnGetMachineStatus(
                            shortName,
                            WorkFlowMachineStatus,
                            WorkFlowStatus
                        ),
                        data: {
                            label: CreateModel(
                                StarterMachine.machinelogo,
                                id,
                                StarterMachine.machinename,
                                shortName,
                                IsWorkFlowIsRunning,
                                sameMachineNo,
                                WorkFlowMachineStatus,
                                WorkFlowStatus,
                                flowDetails
                            ),
                        },
                        configData: configList,
                        infoData: infoDetail,
                        entrypointcommand,
                        cpu,
                        ram,
                        osrequirmet,
                        cloud,
                        PROXY_ENABLED,
                        PROXY_ROTATE_PER_REQUEST,
                        outputdata
                    };

                    setNodes((nds) => [...nds, newNode]);
                }

                setMachineList(groupingJson);

                setAllMachineList(dataFromApi);
            }
            if (!response?.payload?.isValidate) {
                setMachineList(null);
                setMachineDataLoading(false);
                setAllMachineList(null);
            }
        });
    };

    const GetMachineDescription = (id) => {
        let a = allMachineList?.dataList1?.filter((m) => m.machineid === id)[0]
            ?.shortdescription;
        return a;
    };

    const handleNodeClick = (
        event,
        _node,
        _IsWorkFlowIsRunning,
        _WorkFlowMachineStatus,
        _WorkFlowMachineUse
    ) => {

        if (_node.shortName.toUpperCase().indexOf("QD#SYSTEM#SUBWORKFLOW-") < 0) {
            setNewMachineInfo({
                name: commonservices.makeMachineDisplayName(
                    _node?.typeName,
                    _node?.sameMachineNo,
                    _node?.assemblyname,
                    ""
                ),
                ID: _node?.typeid,
                desc: GetMachineDescription(_node?.typeid),
            });
            setSelectedNode(_node);
            if (_IsWorkFlowIsRunning) {
                setTimeout(() => {
                    setActiveRightSidePinnedPanel("summary");
                }, 100);
            } else {
                setTimeout(() => {
                    setActiveRightSidePanel("machine");
                }, 100);
            }
            handleTabClick(0);
            if (_node?.shortName) {
                fnGetMachineLog(
                    _node?.shortName,
                    _WorkFlowMachineStatus,
                    _WorkFlowMachineUse,
                    _IsWorkFlowIsRunning
                );
            }
        }
    };

    const handleEdgeClick = (event, Edge) => {

        if (event) {
            if (event.target.getAttribute("alt") === "Data Profiles") {
                FnOpenDataProfileMappingPopup(Edge.target);
            }
        }
    };

    const FnForsetActiveRightSidePinnedPanel = (data) => {
        setActiveRightSidePinnedPanel(data);
    };

    const handleRemoveNode = (id) => {
        setNodes((nodes) => {
            const nodeIdsToRemove = new Set(getNodeIdsToRemove(id, nodes));
            const updatedNodes = nodes.filter((node) => !nodeIdsToRemove.has(node.id));

            setEdges((edges) =>
                edges.filter(
                    (edge) =>
                        !nodeIdsToRemove.has(edge.source) &&
                        !nodeIdsToRemove.has(edge.target)
                )
            );

            return updatedNodes;
        });
    };

    const handleWorkflowNodesChange = useCallback(
        (changes) => {
            const removedNodeIds = changes
                .filter((change) => change.type === "remove")
                .map((change) => change.id);

            if (!removedNodeIds.length) {
                onNodesChange(changes);
                return;
            }

            const nodeIdsToRemove = new Set(
                removedNodeIds.flatMap((nodeId) => getNodeIdsToRemove(nodeId, nodes))
            );

            const additionalRemoveChanges = Array.from(nodeIdsToRemove)
                .filter((nodeId) => !removedNodeIds.includes(nodeId))
                .map((nodeId) => ({ id: nodeId, type: "remove" }));

            onNodesChange([...changes, ...additionalRemoveChanges]);
            setEdges((edges) =>
                edges.filter(
                    (edge) =>
                        !nodeIdsToRemove.has(edge.source) &&
                        !nodeIdsToRemove.has(edge.target)
                )
            );
        },
        [nodes, onNodesChange, setEdges]
    );

    const FnForSetTrackState = (data) => {
        setTrackState(data);
    };

    const FunForsetActiveSidePanel = (data) => {
        setActiveSidePanel(data);
    };

    const FunForsetActiveSidePanelPinned = (data) => {
        setActiveSidePanelPinned(data);
    };


    const FnForsetSelectedNode = (data) => {
        if (data) {
            if (data.template.toUpperCase() === "LOOPSTART-0-0-0") {
                if (data.configData && data.configData.length > 0) {
                    let loop_type = data.configData.filter((x) => x?.parakey === "loop_type");
                    let loop_key = data.configData.filter((x) => x?.parakey === "loop_key");
                    let loop_list = data.configData.filter((x) => x?.parakey === "loop_list");
                    if (loop_type && loop_type.length > 0 && loop_key && loop_key.length > 0 && loop_list && loop_list.length > 0) {
                        if (loop_type[0].value && loop_type[0].value !== undefined && loop_type[0].value !== null && loop_type[0].value !== "") {
                            let _LoopData = [];
                            if (loop_type[0].value.toUpperCase() === "BASED ON OUTPUT") {

                                if (data?.loopKeySampleData && data?.loopKeySampleData !== undefined && data?.loopKeySampleData !== null && data?.loopKeySampleData !== "") {
                                    try {
                                        let loopList = JSON.parse(data?.loopKeySampleData);

                                        const isArrayData = Array.isArray(loopList);
                                        const isObjectArray =
                                            isArrayData &&
                                            loopList.every(
                                                (item) =>
                                                    typeof item === "object" &&
                                                    !Array.isArray(item) &&
                                                    item !== null
                                            );
                                        const isPrimitiveArray =
                                            isArrayData &&
                                            loopList.every(
                                                (item) =>
                                                    ["string", "number", "boolean"].includes(typeof item)
                                            );

                                        if (!isArrayData || (!isObjectArray && !isPrimitiveArray)) {


                                        } else {
                                            _LoopData = loopList;
                                        }

                                    } catch (err) {

                                    }
                                }
                            }
                            else if (loop_type[0].value.toUpperCase() === "FIX") {
                                if (loop_list[0].value && loop_list[0].value !== undefined && loop_list[0].value !== null && loop_list[0].value !== "") {
                                    try {
                                        let loopList = JSON.parse(loop_list[0].value);

                                        const isArrayData = Array.isArray(loopList);
                                        const isObjectArray =
                                            isArrayData &&
                                            loopList.every(
                                                (item) =>
                                                    typeof item === "object" &&
                                                    !Array.isArray(item) &&
                                                    item !== null
                                            );
                                        const isPrimitiveArray =
                                            isArrayData &&
                                            loopList.every(
                                                (item) =>
                                                    ["string", "number", "boolean"].includes(typeof item)
                                            );

                                        if (!isArrayData || (!isObjectArray && !isPrimitiveArray)) {


                                        } else {
                                            _LoopData = loopList;
                                        }

                                    } catch (err) {

                                    }
                                }
                            }

                            let LoopDataKeys = [];

                            if (_LoopData && _LoopData.length > 0) {
                                const keyPathSet = commonservices.getJsonPathsWithType_WithouArrayKayWherePosition(_LoopData[0]);
                                Array.from(keyPathSet).forEach((keyPath) => {
                                    LoopDataKeys.push({ "name": keyPath.key, "value": "", "inputType": commonservices.getQDDataTypeBaseOnType(keyPath.type) });
                                });
                            }
                            else {
                                LoopDataKeys.push({ "name": "data", "value": "", "inputType": "Text Box" });
                            }
                            setLoop_sample_data(LoopDataKeys);
                        }
                    }
                }
            }
        }
        setSelectedNode(data);
    };


    function fnGetMachineStatus(shortName, WFMData, WFData) {
        let status = "";
        if (WFMData && WFMData.length !== 0) {
            let data = WFMData.filter(
                (i) => i.workflowmachinename?.toUpperCase() === shortName?.toUpperCase()
            );
            if (data && data.length > 0) {
                status = data[0].status;
            }
        }

        if (shortName === "loopend-0-0-0" || shortName === "loopstart-0-0-0") {
            status = "node-opration";
        }
        return status;
    }

    function fnGetMachineOutputData(shortName, MachineLogData) {
        let outputdata = "";
        if (MachineLogData && MachineLogData.length > 0) {
            let Fmachine = MachineLogData.filter((m) => m.workflowmachinename === shortName);
            if (Fmachine && Fmachine.length > 0) {
                if (Fmachine[0].outputdata) {
                    outputdata = Fmachine[0].outputdata;
                }
            }
        }
        return outputdata;
    }

    const FindRelatedMachine = (assemblyname) => {
        let relatedMachine = allMachineDetails.filter(
            (x) => x.assemblyname === assemblyname
        );
        return relatedMachine;
    };

    const AddLoopComponent = (StarterMachine, x, y) => {
        let nc = CalculateNodePositionAndWidthHeight(
            null,
            StarterMachine.assemblyname
        );
        let position = {
            x: x,
            y: y + nc.h + 20,
        };
        const id = GenerateGUID();
        const typeid = StarterMachine?.machineid;
        const typeName = StarterMachine?.machinename;
        const image = StarterMachine?.machinelogo;
        const dockerimagename = StarterMachine?.dockerimagename;
        let shortName = StarterMachine?.assemblyname;
        const template = StarterMachine?.assemblyname;
        let sameMachineNo = 0;

        let NoOfMachineExist = nodes.filter(
            (x) => x.dockerimagename === dockerimagename
        );
        if (NoOfMachineExist !== null && NoOfMachineExist.length !== 0) {
            NoOfMachineExist.sort((a, b) =>
                a.sameMachineNo > b.sameMachineNo
                    ? 1
                    : b.sameMachineNo > a.sameMachineNo
                        ? -1
                        : 0
            );

            sameMachineNo =
                NoOfMachineExist[NoOfMachineExist.length - 1].sameMachineNo + 1;
            shortName = shortName + sameMachineNo;
        }
        const entrypointcommand = StarterMachine?.entrypointcommand;
        const cpu = StarterMachine?.cpu;
        const ram = StarterMachine?.ram;
        const osrequirmet = StarterMachine?.osrequirmet;
        const cloud = StarterMachine?.cloud;
        const configList = allMachineList?.dataList2?.filter(
            (x) => x?.machineid == StarterMachine?.machineid
        );
        const infoDetail = allMachineList?.dataList3?.filter(
            (x) => x?.machineid == StarterMachine?.machineid
        );
        const PROXY_ENABLED = StarterMachine?.PROXY_ENABLED || false;
        const PROXY_ROTATE_PER_REQUEST = StarterMachine?.PROXY_ROTATE_PER_REQUEST || true;
        let outputdata = "";

        const newNode = {
            id,
            typeid,
            typeName,
            position,
            image,
            dockerimagename,
            shortName,
            machine_version: StarterMachine?.versionnumber,
            template: template,
            sameMachineNo: sameMachineNo,
            className: fnGetMachineStatus(
                shortName,
                WorkFlowMachineStatus,
                WorkFlowStatus
            ),
            data: {
                label: CreateModel(
                    StarterMachine.machinelogo,
                    id,
                    StarterMachine.machinename,
                    shortName,
                    IsWorkFlowIsRunning,
                    sameMachineNo,
                    WorkFlowMachineStatus,
                    WorkFlowStatus,
                    flowDetails
                ),
            },
            configData: configList,
            infoData: infoDetail,
            entrypointcommand,
            cpu,
            ram,
            osrequirmet,
            cloud,
            PROXY_ENABLED,
            PROXY_ROTATE_PER_REQUEST,
            outputdata
        };
        setNodes((nds) => [...nds, newNode]);
    };

    const onDrop = useCallback(
        (event) => {
            if (event.dataTransfer.getData("application/reactflow")) {
                event.preventDefault();
                const type = JSON.parse(
                    event.dataTransfer.getData("application/reactflow")
                );
                let gets = nodes?.filter(
                    (x) =>
                        x.shortName === "loopend-0-0-0" || x.shortName === "loopstart-0-0-0"
                );
                if (
                    gets.length > 0 &&
                    (type?.assemblyname === "loopstart-0-0-0" ||
                        type?.assemblyname === "loopend-0-0-0")
                ) {
                    toast.info("Loop already exist");
                    return;
                }

                const position = CalculateNodePositionAndWidthHeight(
                    event,
                    type?.assemblyname
                );

                if (
                    type?.assemblyname === "loopend-0-0-0" ||
                    type?.assemblyname === "loopstart-0-0-0"
                ) {
                    const id = GenerateGUID();
                    const typeid = type?.machineid;
                    const typeName = type?.machinename;
                    const price = type?.price;
                    const image = type?.machinelogo;
                    const dockerimagename = type?.dockerimagename;
                    let shortName = type?.assemblyname;
                    const template = type?.assemblyname;
                    let sameMachineNo = 0;

                    let NoOfMachineExist = nodes.filter(
                        (x) => x.dockerimagename === dockerimagename
                    );
                    if (NoOfMachineExist !== null && NoOfMachineExist.length !== 0) {
                        NoOfMachineExist.sort((a, b) =>
                            a.sameMachineNo > b.sameMachineNo
                                ? 1
                                : b.sameMachineNo > a.sameMachineNo
                                    ? -1
                                    : 0
                        );

                        sameMachineNo =
                            NoOfMachineExist[NoOfMachineExist.length - 1].sameMachineNo + 1;
                        shortName = shortName + sameMachineNo;
                    }
                    const entrypointcommand = type?.entrypointcommand;
                    const cpu = type?.cpu;
                    const ram = type?.ram;
                    const osrequirmet = type?.osrequirmet;
                    const cloud = type?.cloud;

                    const configList = allMachineList?.dataList2?.filter(
                        (x) => x?.machineid == type?.machineid
                    );
                    const infoDetail = allMachineList?.dataList3?.filter(
                        (x) => x?.machineid == type?.machineid
                    );
                    const PROXY_ENABLED = type?.PROXY_ENABLED || false;
                    const PROXY_ROTATE_PER_REQUEST = type?.PROXY_ROTATE_PER_REQUEST || true;
                    let outputdata = "";

                    const newNode = {
                        id,
                        typeid,
                        typeName,
                        position,
                        image,
                        dockerimagename,
                        shortName,
                        price,
                        machine_version: type?.versionnumber,
                        template: template,
                        sameMachineNo: sameMachineNo,
                        className: fnGetMachineStatus(
                            shortName,
                            WorkFlowMachineStatus,
                            WorkFlowStatus
                        ),
                        data: {
                            label: CreateModel(
                                type.machinelogo,
                                id,
                                type.machinename,
                                shortName,
                                IsWorkFlowIsRunning,
                                sameMachineNo,
                                WorkFlowMachineStatus,
                                WorkFlowStatus,
                                flowDetails
                            ),
                        },
                        configData: configList,
                        infoData: infoDetail,
                        entrypointcommand,
                        cpu,
                        ram,
                        osrequirmet,
                        cloud,
                        PROXY_ENABLED,
                        PROXY_ROTATE_PER_REQUEST,
                        outputdata
                    };
                    setNodes((nds) => [...nds, newNode]);

                    let a = FindRelatedMachine(
                        type?.assemblyname === "loopend-0-0-0"
                            ? "loopstart-0-0-0"
                            : "loopend-0-0-0"
                    );
                    AddLoopComponent(a[0], position.x, position.y);
                } else {
                    const id = GenerateGUID();
                    const typeid = type?.machineid;
                    const typeName = type?.machinename;
                    const price = type?.price;
                    const image = type?.machinelogo;
                    const dockerimagename = type?.dockerimagename;
                    let shortName = type?.assemblyname;
                    const template = type?.assemblyname;
                    let sameMachineNo = 0;

                    let NoOfMachineExist = nodes.filter(
                        (x) => x.dockerimagename === dockerimagename
                    );
                    if (NoOfMachineExist !== null && NoOfMachineExist.length !== 0) {
                        NoOfMachineExist.sort((a, b) =>
                            a.sameMachineNo > b.sameMachineNo
                                ? 1
                                : b.sameMachineNo > a.sameMachineNo
                                    ? -1
                                    : 0
                        );

                        sameMachineNo =
                            NoOfMachineExist[NoOfMachineExist.length - 1].sameMachineNo + 1;
                        shortName = shortName + sameMachineNo;
                    }
                    const entrypointcommand = type?.entrypointcommand;
                    const cpu = type?.cpu;
                    const ram = type?.ram;
                    const osrequirmet = type?.osrequirmet;
                    const cloud = type?.cloud;

                    const configList = allMachineList?.dataList2?.filter(
                        (x) => x?.machineid == type?.machineid
                    );
                    const infoDetail = allMachineList?.dataList3?.filter(
                        (x) => x?.machineid == type?.machineid
                    );
                    const PROXY_ENABLED = type?.PROXY_ENABLED || false;
                    const PROXY_ROTATE_PER_REQUEST = type?.PROXY_ROTATE_PER_REQUEST || true;
                    let outputdata = "";

                    const newNode = {
                        id,
                        typeid,
                        typeName,
                        position,
                        image,
                        dockerimagename,
                        shortName,
                        price,
                        machine_version: type?.versionnumber,
                        template: template,
                        sameMachineNo: sameMachineNo,
                        className: fnGetMachineStatus(
                            shortName,
                            WorkFlowMachineStatus,
                            WorkFlowStatus
                        ),
                        data: {
                            label: CreateModel(
                                type.machinelogo,
                                id,
                                type.machinename,
                                shortName,
                                IsWorkFlowIsRunning,
                                sameMachineNo,
                                WorkFlowMachineStatus,
                                WorkFlowStatus,
                                flowDetails
                            ),
                        },
                        configData: configList,
                        infoData: infoDetail,
                        entrypointcommand,
                        cpu,
                        ram,
                        osrequirmet,
                        cloud,
                        PROXY_ENABLED,
                        PROXY_ROTATE_PER_REQUEST,
                        outputdata
                    };
                    setNodes((nds) => [...nds, newNode]);
                }
            }
        },
        [nodes, setNodes]
    );

    function GenerateGUID() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            function (c) {
                const r = (Math.random() * 16) | 0,
                    v = c == "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            }
        );
    }

    const onConnect = useCallback(

        (params) => {

            let connectingNodeData = nodes.find((n) => n.id === params.source);

            let targetNodeData = nodes.find((n) => n.id === params.target);
            if (connectingNodeData && targetNodeData) {
                if (connectingNodeData.shortName.toUpperCase().indexOf("QD#SYSTEM#SUBWORKFLOW-") < 0) {
                    const newEdge = {
                        id: `${GenerateGUID()}`,
                        source_machineid: `${connectingNodeData.typeid}`,
                        source_machinename: `${connectingNodeData.typeName}`,
                        source_image: `${connectingNodeData.dockerimagename}`,
                        source_shortname: `${connectingNodeData.shortName}`,
                        source: params.source,
                        target: params.target,
                        target_machineid: `${targetNodeData.typeid}`,
                        target_machinename: `${targetNodeData.typeName}`,
                        target_image: `${targetNodeData.dockerimagename}`,
                        target_shortname: `${targetNodeData.shortName}`,
                        type: Edgetype,
                    };

                    const edgeExists = edges.some(
                        (edge) =>
                            edge.source === newEdge.source && edge.target === newEdge.target
                    );

                    if (!edgeExists) {
                        setEdges((eds) => addEdge(newEdge, eds));
                    }
                }
            }
        },
        [edges, setEdges]
    );

    const isValidJson = (text) => {
        if (typeof text !== "string") {
            return false;
        }
        try {
            JSON.parse(text);
            return true;
        } catch (error) {
            return false;
        }
    };

    const MAX_TASK_ARGUMENTS_BYTES = 64 * 1024;

    const getUtf8ByteSize = (value) => {
        try {
            return new TextEncoder().encode(value || "").length;
        } catch (error) {
            return unescape(encodeURIComponent(value || "")).length;
        }
    };

    const getTaskArgumentsOversizeMachines = (tasks) => {
        if (!Array.isArray(tasks) || tasks.length === 0) {
            return [];
        }

        const oversizedMachines = [];

        tasks.forEach((task) => {
            const taskArguments = task?.arguments ? JSON.stringify(task.arguments) : "";
            const argumentSizeBytes = getUtf8ByteSize(taskArguments);

            if (argumentSizeBytes > MAX_TASK_ARGUMENTS_BYTES) {
                oversizedMachines.push(
                    commonservices.makeMachineDisplayName(
                        task?.workflowmachinename,
                        0,
                        task?.name,
                        ""
                    ) || task?.workflowmachinename || task?.name || "Unknown machine"
                );
            }
        });

        return [...new Set(oversizedMachines)];
    };

    const handleConfigValidation = () => {
        let nodeErrorArr = [];

        let updatedNodes = nodes?.map((item) => {
            let isErrorExists = false;
            let updatedConfig = item?.configData?.map((configItem) => {
                if (configItem?.paratype === "Json" && configItem?.value) {
                    let isJsonValid = isValidJson(configItem?.value);
                    if (!isJsonValid) {
                        isErrorExists = true;
                        configItem.error = true;
                        nodeErrorArr.push(item);
                    } else {
                        configItem.error = false;
                    }
                }
                return configItem;
            });
            item.configData = updatedConfig;
            if (isErrorExists) {
                nodeErrorArr.push(item);
            }
            return item;
        });

        return { nodeErrorArr, updatedNodes };
    };


    const ARGO_RAW_PARAM_KEY = "__argoRawParam__";
    const stringifyWithRawWorkflowParams = (payload) => {
        const serializedPayload = JSON.stringify(payload);
        const rawParamRegex = new RegExp(
            `\\{\\"${ARGO_RAW_PARAM_KEY}\\":\\"(\\{\\{(?:workflow\\.parameters\\.[^\\\"]+|inputs\\.parameters\\.data|=jsonpath\\([^\\\"]+\\))\\}\\})\\"\\}`,
            "g"
        );

        return serializedPayload.replace(rawParamRegex, "$1");
    };

    const parseWithRawWorkflowParams = (serializedPayload) => {
        if (!serializedPayload) {
            return {};
        }

        const normalizedPayload = serializedPayload.replace(
            /:\s*(\{\{(?:workflow\.parameters\.[^}]+|inputs\.parameters\.data|=jsonpath\([^}]+\))\}\})(\s*[,}])/g,
            `:{"${ARGO_RAW_PARAM_KEY}":"$1"}$2`
        );

        return JSON.parse(normalizedPayload);
    };

    const createWorkflowJson = () => {
        let MachinesFiles = [];

        let _parametersforworkflow = parametersforworkflow ? parametersforworkflow.filter(item => item.name !== "loops") : []

        let groupingJson = {
            name: "#YAMLWORKFLOWNAME#",
            workflowname: flowName,
            code: "#code#",
            inputs: {},
            outputs: {},
            metadata: {},
            schedule: "0 0 1 1 *",
            loopparam: JSON.stringify([]),
            loop_list: "",
            loop_type: "",
            loop_key: "",
            loop_sample_data: JSON.stringify([]),
            timezone: Userdata.timezone,
            dag: {
                tasks: [],
            },
            workflowid: "1001001.101",
            mode: process.env.REACT_APP_APIBASEPATH?.includes("//api")
                ? "prod"
                : "smoke",
            logdata:
                '{"userid": 1001001.102,"workflowid": "#workflowid#","log_type": "","log_message": "#log_message#","env": "#env#","log_from": "#log_from#"}',
            retryStrategy: retrystrategy ? retrystrategy : 1,
            parallelism: parallelism ? parallelism : 1,
            nodegroup: eksnodegroup ? eksnodegroup : "",
            arguments: {
                "parameters": _parametersforworkflow ? _parametersforworkflow : []
            }
        };

        let NoOfParentNode = 0;

        let NewNodeData = commonservices.TopOlogicalSort(nodes, edges);

        let SubWorkflowDetails = [];

        NewNodeData?.forEach((item) => {

            let obj = {
                name: item?.shortName,
                template: item?.shortName.replace("-Loop-{{inputs.parameters.count}}", ""), // template: item?.template,
                images: item?.dockerimagename ? item?.dockerimagename : "",
                entrypointcommand: item?.entrypointcommand
                    ? item?.entrypointcommand.toLowerCase()
                    : "main.py",
                cpu: item?.cpu ? item?.cpu : "500m",
                ram: item?.ram ? item?.ram : "256Mi",
                osrequirmet: item?.osrequirmet ? item?.osrequirmet : "Linux",
                cloud: item?.cloud ? item?.cloud : "AWS",
                PROXY_ENABLED: item?.PROXY_ENABLED ? item?.PROXY_ENABLED : false,
                PROXY_ROTATE_PER_REQUEST: item?.PROXY_ROTATE_PER_REQUEST
                    ? item?.PROXY_ROTATE_PER_REQUEST
                    : true,
                arguments: {
                    parameters: {
                        name: "args",
                        value: "",
                    },
                },
                dependencies: [],
                fulldependencies: [],
                machineid: item.typeid,
                workflowmachinename: item.typeName,
                condition_list: item?.condition_list && item?.condition_list.length > 0 ? item?.condition_list : "",
                output_para: [],
                condition: ""
            };

            let objForParaValue = {};

            item?.configData?.forEach((configItem) => {

                // let newID = GenerateGUID();
                let valueForConfig = "";
                if (configItem?.valuetype && configItem?.workflowparavalue) {
                    const paraType = (configItem?.paratype || "").toUpperCase();
                    if (configItem?.valuetype.toUpperCase() === "GLOBAL PARAMETER") {
                        const workflowParamRef = `{{workflow.parameters.${configItem?.workflowparavalue}}}`;
                        if (paraType === "NUMBER" || paraType === "DECIMAL" || paraType === "JSON") {
                            valueForConfig = { [ARGO_RAW_PARAM_KEY]: workflowParamRef };
                        }
                        else {
                            valueForConfig = workflowParamRef;
                        }
                    }
                    else if (configItem?.valuetype.toUpperCase() === "LOOP KEY") {
                        const loopKeyRef = `{{=jsonpath(inputs.parameters.data,'$.${configItem?.workflowparavalue.replace("data.", "")}')}}`;
                        valueForConfig = loopKeyRef;
                        if (paraType === "NUMBER" || paraType === "DECIMAL") {
                            if (paraType === "NUMBER") {
                                valueForConfig = `{{=asInt(jsonpath(inputs.parameters.data,'$.${configItem?.workflowparavalue.replace("data.", "")}'))}}`;
                            }
                            else if (paraType === "DECIMAL") {
                                valueForConfig = `{{=asFloat(jsonpath(inputs.parameters.data,'$.${configItem?.workflowparavalue.replace("data.", "")}'))}}`;
                            }
                        }
                        else {
                            valueForConfig = loopKeyRef;
                        }
                        if (configItem?.workflowparavalue.toUpperCase() === "DATA") {
                            if (paraType === "NUMBER" || paraType === "DECIMAL" || paraType === "JSON") {
                                valueForConfig = { [ARGO_RAW_PARAM_KEY]: `{{inputs.parameters.data}}` };
                            }
                            else {
                                valueForConfig = `{{inputs.parameters.data}}`;
                            }
                        }
                    }
                }
                else {
                    if (configItem?.value) {
                        valueForConfig = configItem?.value;
                    }

                    if (configItem?.paratype.toUpperCase() === "NUMBER" && configItem?.value) {
                        valueForConfig = parseInt(configItem?.value);
                    }

                    if (configItem?.paratype.toUpperCase() === "DECIMAL" && configItem?.value) {
                        valueForConfig = parseFloat(configItem?.value);
                    }

                    if (configItem?.paratype.toUpperCase() === "JSON" && configItem?.value) {
                        valueForConfig = JSON.parse(configItem?.value);
                    }

                    if (configItem?.paratype.toUpperCase() === "FILE" && configItem?.value) {
                        valueForConfig = configItem?.file
                        if (configItem?.file instanceof File) {
                            valueForConfig = item.id + commonservices.getFileExtension(configItem?.file.name);
                            MachinesFiles.push({
                                title: valueForConfig,
                                file: configItem?.file
                            });
                        }
                    }
                }



                objForParaValue = {
                    ...objForParaValue,
                    [configItem?.parakey]: valueForConfig,
                };

            });

            if (obj.images) {
                if (obj.images.toUpperCase().indexOf("/LAMBDA:") >= 0) {
                    if ("code_source" in objForParaValue) {
                        if (objForParaValue.code_source) {
                            if (objForParaValue.code_source.toUpperCase() === "FILE" || objForParaValue.code_source.toUpperCase() === "ZIP") {
                                objForParaValue.code_source = "s3";
                            }
                        }
                    }
                }
            }


            let findDependencies = edges?.filter((x) => x?.target === item?.id);

            if (findDependencies?.length > 0) {
                let names = [];
                let fullnames = [];

                findDependencies?.forEach((dependenciesItem) => {
                    let n = NewNodeData?.find(
                        (item) => item?.id === dependenciesItem?.source
                    )?.shortName;
                    if (n) {
                        fullnames.push(n.replace("-Loop-{{inputs.parameters.count}}", ""));
                    }
                    if (n) {
                        if (n.toLowerCase().indexOf("loopstart-0-0-0") >= 0) {
                            n = "startloop";
                        }

                        if (n.toLowerCase().indexOf("loopend-0-0-0") >= 0) {
                            n = "loop";
                        }
                    }
                    if (n) {
                        names.push(n);
                    }
                });

                obj.dependencies = names.filter(
                    (value, index, self) => self.indexOf(value) === index
                );

                obj.fulldependencies = fullnames.filter(
                    (value, index, self) => self.indexOf(value) === index
                );
            } else {
                NoOfParentNode = NoOfParentNode + 1;
            }

            let findMachineVersion = allMachineList?.dataList1?.filter(
                (x) => x?.machineid == item?.typeid
            );

            if (findMachineVersion?.length > 0) {
                item.machine_version = findMachineVersion?.[0]?.versionnumber;
            }

            let _condition_list = [];

            if (item?.condition_list && item?.condition_list.length > 0) {
                _condition_list = item?.condition_list.filter(item => item.parentmachine !== "loopstart-0-0-0");
            }

            let objForValue = {
                machine_name: item?.shortName,
                machinetemplate_name: item?.template,
                workflow_name: flowName ? flowName?.trim() : flowName,
                machine_version: item?.machine_version,
                workflowid: 1001001.101,
                subscriberid: Userdata?.subscriberid,
                machineid: item?.typeid,
                mode: process.env.REACT_APP_APIBASEPATH?.includes("//api")
                    ? "prod"
                    : "smoke",
                isautorun: true,
                prog_lang: "python",
                input_data: objForParaValue,
                output: item?.shortName + ".json",
                depends_machine: obj?.dependencies,
                dataprofile_query: item?.dataprofile_query ? item?.dataprofile_query : "",
                condition_list: _condition_list && _condition_list.length > 0 ? _condition_list : "",
                output_para: {},
            };

            obj.arguments.parameters.value = stringifyWithRawWorkflowParams(objForValue);

            groupingJson.dag.tasks.push(obj);
        });

        let checkisloop = groupingJson?.dag?.tasks?.filter(
            (n) => n?.template === "loopstart-0-0-0"
        );

        if (checkisloop && checkisloop.length > 0) {
            let loopdata = parseWithRawWorkflowParams(checkisloop[0].arguments.parameters.value);

            let loop_list = loopdata?.input_data?.loop_list
            let loop_type = loopdata?.input_data?.loop_type
            let loop_key = loopdata?.input_data?.loop_key
            let output_from = loopdata?.input_data?.output_from
            if (loop_type) {
                groupingJson.loop_type = loop_type.toUpperCase();

                if (loop_type.toUpperCase() === "FIX") {

                    if (loop_list) {
                        const isArrayData = Array.isArray(loop_list);
                        const isObjectArray =
                            isArrayData &&
                            loop_list.every(
                                (item) =>
                                    typeof item === "object" &&
                                    !Array.isArray(item) &&
                                    item !== null
                            );
                        const isPrimitiveArray =
                            isArrayData &&
                            loop_list.every(
                                (item) =>
                                    ["string", "number", "boolean"].includes(typeof item)
                            );

                        if (!isArrayData || (!isObjectArray && !isPrimitiveArray)) {
                            toast.error(
                                "Loop Start must contain either object array or value array format"
                            );
                            return;
                        } else {
                            groupingJson.loop_sample_data = JSON.stringify(loop_sample_data);
                            groupingJson.loop_list = JSON.stringify(loop_list);
                            groupingJson.arguments.parameters.push({ "name": "loops", "value": JSON.stringify(loop_list), "isvalid": "", "isvalidName": "" });
                        }

                    } else {
                        toast.error("Loop Start must has data");
                        return;
                    }
                }
                else if (loop_type.toUpperCase() === "BASED ON OUTPUT") {
                    if (loop_key && output_from) {
                        groupingJson.loop_sample_data = JSON.stringify(loop_sample_data);
                        groupingJson.loop_list = output_from;
                        groupingJson.loop_key = loop_key;
                        groupingJson.arguments.parameters.push({ "name": "loops", "value": JSON.stringify([]), "isvalid": "", "isvalidName": "" });
                    }
                    else {
                        toast.error("Loop Start must has data");
                        return;
                    }
                }
                else {
                    toast.error("Loop Start must has data");
                    return;
                }
            }
            else {
                toast.error("Loop Start must has data");
                return;
            }

        }

        groupingJson?.dag?.tasks?.forEach((TasksItem) => {
            let dependencies = [];
            if (TasksItem.dependencies && TasksItem.dependencies.length > 0) {
                TasksItem.dependencies.forEach((d) => {
                    if (d) {
                        if (d.toLowerCase() === "loop") {
                            TasksItem.dependencies.forEach((d_d) => {
                                if (d_d && d_d.toLowerCase() !== "loop") {
                                    dependencies.push(d_d);
                                }
                            });
                            let findloopenddependencies = groupingJson?.dag?.tasks?.filter(
                                (n) => n?.template === "loopend-0-0-0"
                            );
                            if (
                                findloopenddependencies &&
                                findloopenddependencies.length > 0
                            ) {
                                if (
                                    findloopenddependencies[0].fulldependencies &&
                                    findloopenddependencies[0].fulldependencies.length > 0
                                ) {
                                    findloopenddependencies[0].fulldependencies.forEach(
                                        (loopend_d) => {
                                            if (loopend_d) {
                                                dependencies.push(loopend_d);
                                            }
                                        }
                                    );
                                }
                            }
                            if (TasksItem.arguments.parameters.value) {
                                let val = parseWithRawWorkflowParams(TasksItem.arguments.parameters.value);
                                val.depends_machine = dependencies;
                                TasksItem.arguments.parameters.value = stringifyWithRawWorkflowParams(val);
                            }
                        }
                    }
                });
            }
        });

        groupingJson?.dag?.tasks?.forEach((TasksItem) => {
            let dependencies = [];
            if (TasksItem.dependencies && TasksItem.dependencies.length > 0) {
                TasksItem.dependencies.forEach((d) => {
                    if (d) {
                        if (d.toLowerCase() === "startloop") {
                            TasksItem.dependencies.forEach((d_d) => {
                                if (d_d && d_d.toLowerCase() !== "startloop") {
                                    dependencies.push(d_d);
                                }
                            });
                            let findloopenddependencies = groupingJson?.dag?.tasks?.filter(
                                (n) => n?.template === "loopstart-0-0-0"
                            );
                            if (
                                findloopenddependencies &&
                                findloopenddependencies.length > 0
                            ) {
                                if (
                                    findloopenddependencies[0].fulldependencies &&
                                    findloopenddependencies[0].fulldependencies.length > 0
                                ) {
                                    findloopenddependencies[0].fulldependencies.forEach(
                                        (loopend_d) => {
                                            if (loopend_d) {
                                                dependencies.push(loopend_d);
                                            }
                                        }
                                    );
                                }
                            }
                            if (TasksItem.arguments.parameters.value) {
                                let val = parseWithRawWorkflowParams(TasksItem.arguments.parameters.value);
                                val.depends_machine = dependencies;
                                TasksItem.arguments.parameters.value = stringifyWithRawWorkflowParams(val);
                            }
                        }
                    }
                });
            }

            dependencies = [];
            if (TasksItem.dependencies && TasksItem.dependencies.length > 0) {
                TasksItem.dependencies.forEach((d) => {
                    if (d && d.toLowerCase() !== "startloop") {
                        dependencies.push(d);
                    }
                });
            }
            TasksItem.dependencies = dependencies;
        });

        let checkisSUBWORKFLOW = groupingJson?.dag?.tasks?.filter(
            (n) => n?.images === "SUBWORKFLOW"
        );

        if (checkisSUBWORKFLOW && checkisSUBWORKFLOW.length > 0) {
            groupingJson?.dag?.tasks?.forEach((TasksItem) => {
                if (TasksItem.images === "SUBWORKFLOW") {
                    groupingJson?.dag?.tasks?.forEach((SubTasksItem) => {
                        if (SubTasksItem.dependencies && SubTasksItem.dependencies.length > 0 && TasksItem.dependencies && TasksItem.dependencies.length > 0) {
                            const exists = SubTasksItem.dependencies.includes(TasksItem.name);
                            if (exists) {
                                TasksItem.dependencies.forEach((d) => SubTasksItem.dependencies.push(d));

                                const index = SubTasksItem.dependencies.indexOf(TasksItem.name);
                                if (index !== -1) {
                                    SubTasksItem.dependencies.splice(index, 1);
                                }

                                SubTasksItem.dependencies = [...new Set(SubTasksItem.dependencies)];

                                if (SubTasksItem.arguments.parameters.value) {
                                    let val = parseWithRawWorkflowParams(SubTasksItem.arguments.parameters.value);
                                    val.depends_machine = SubTasksItem.dependencies;
                                    SubTasksItem.arguments.parameters.value = stringifyWithRawWorkflowParams(val);
                                }
                            }
                        }
                    });

                    if (TasksItem.machineid && TasksItem.dependencies && TasksItem.dependencies.length > 0 && TasksItem.machineid) {

                        SubWorkflowDetails.push({ subworkflowid: TasksItem.machineid, dependencies: TasksItem.dependencies.join(","), name: TasksItem.workflowmachinename });
                    }
                }
            });

            groupingJson.dag.tasks = groupingJson?.dag?.tasks.filter(item => item.images !== "SUBWORKFLOW");
        }

        let IsAnyInvalidSubWorkflow = [];

        if (SubWorkflowDetails && SubWorkflowDetails.length > 0) {
            for (let i = 0; i < SubWorkflowDetails.length; i++) {
                let F = allMachineDetails.filter((m) => m.machineid === SubWorkflowDetails[i].subworkflowid);
                if (F && F.length > 0) {

                }
                else {
                    IsAnyInvalidSubWorkflow.push(SubWorkflowDetails[i]);
                }
            }
        }

        groupingJson?.dag?.tasks?.forEach((TasksItem) => {
            if (TasksItem?.condition_list && TasksItem?.condition_list.length > 0) {

                let condition = { logic: "" };
                let logic = "";
                for (let c = 0; c < TasksItem?.condition_list.length; c++) {
                    let isLoopStart = TasksItem?.condition_list[c].parentmachine === "loopstart-0-0-0";
                    let key = "";
                    if (isLoopStart) {
                        if (TasksItem?.condition_list[c].expression.toUpperCase().indexOf("DATA.") >= 0) {
                            if (Number(TasksItem?.condition_list[c].value)) {
                                if (TasksItem?.condition_list[c].value.indexOf(".") >= 0) {
                                    key = "{{=asFloat(jsonpath(inputs.parameters.data, '$." + TasksItem?.condition_list[c].expression.replace("data.", "") + "'))}}";
                                }
                                else {
                                    key = "{{=asInt(jsonpath(inputs.parameters.data, '$." + TasksItem?.condition_list[c].expression.replace("data.", "") + "'))}}";
                                }
                            }
                            else {
                                key = "{{=jsonpath(inputs.parameters.data, '$." + TasksItem?.condition_list[c].expression.replace("data.", "") + "')}}";
                            }
                        }
                        else {
                            key = "{{inputs.parameters.data}}";
                        }
                    }
                    else {
                        key = TasksItem?.condition_list[c].expression;
                    }

                    logic = logic + " " + TasksItem?.condition_list[c].condition + " " + TasksItem?.condition_list[c].name;
                    condition[TasksItem?.condition_list[c].name] = {
                        name: TasksItem?.condition_list[c].name,
                        parent: TasksItem?.condition_list[c].parentmachine,
                        conditionexpression: TasksItem?.condition_list[c].name + " " + TasksItem?.condition_list[c].operation + " " + TasksItem?.condition_list[c].value,
                        key: key
                    }

                    let conditionparentfilter = groupingJson?.dag?.tasks?.filter(
                        (conditionparent) =>
                            conditionparent.name.replace(
                                "-Loop-{{inputs.parameters.count}}",
                                "",
                            ) ===
                            TasksItem?.condition_list[c].parentmachine,
                    );
                    if (conditionparentfilter && conditionparentfilter.length > 0) {
                        conditionparentfilter[0].output_para.push(TasksItem?.condition_list[c].name);

                        if (conditionparentfilter[0].arguments.parameters.value) {
                            let val = parseWithRawWorkflowParams(conditionparentfilter[0].arguments.parameters.value);
                            val.output_para[TasksItem?.condition_list[c].name] = TasksItem?.condition_list[c].expression;
                            conditionparentfilter[0].arguments.parameters.value = stringifyWithRawWorkflowParams(val);
                        }
                        if (
                            conditionparentfilter[0].name.includes(
                                "-Loop-{{inputs.parameters.count}}",
                            )
                        ) {

                            condition[TasksItem?.condition_list[c].name].parent =
                                condition[TasksItem?.condition_list[c].name].parent + "-Loop-{{inputs.parameters.count}}";
                        }
                    }
                }
                condition.logic = logic.trim();
                TasksItem.condition = condition;
            }
        });


        return { groupingJson, NoOfParentNode, SubWorkflowDetails, IsAnyInvalidSubWorkflow, MachinesFiles };
    };

    const BindDataByID = (workflowid, workflowulogid) => {
        if (workflowid > 0) {
            let body = {
                id: parseInt(workflowid),
            };
            dispatch(GetSandboxWorkFlowByID(body));
        }
    };

    const calculateOffsets = () => {
        const leftOffset = activeSidePanel ? 340 : 38;
        const rightOffset = activeRightSidePanel !== "sm-panel" ? 399 : 38;
        return {
            leftOffset,
            rightOffset,
        };
    };

    const handleSidepanelClick = () => {
        if (activeSidePanelPinned) {
            setActiveSidePanel(activeSidePanelPinned);
        } else {
            setActiveSidePanel(!activeSidePanel);
        }
    };

    const getLayoutedElements = (
        nodes,
        edges,
        direction = "TB",
        viewportWidth = 800,
        viewportHeight = 600
    ) => {
        if (document.getElementById("canvas-workflow-wrapper-ReactFlow")) {
            viewportWidth = document.getElementById(
                "canvas-workflow-wrapper-ReactFlow"
            ).clientWidth;
            viewportHeight = document.getElementById(
                "canvas-workflow-wrapper-ReactFlow"
            ).clientHeight;
        }

        const dagreGraph = new dagre.graphlib.Graph();
        dagreGraph.setDefaultEdgeLabel(() => ({}));

        dagreGraph.setGraph({ rankdir: direction });

        nodes.forEach((node) => {
            dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
        });

        edges.forEach((edge) => {
            dagreGraph.setEdge(edge.source, edge.target);
        });

        dagre.layout(dagreGraph);

        // Compute node positions
        let minX = Infinity,
            minY = Infinity,
            maxX = -Infinity,
            maxY = -Infinity;
        nodes.forEach((node) => {
            const nodeWithPosition = dagreGraph.node(node.id);
            node.position = {
                x: nodeWithPosition.x - nodeWidth / 2,
                y: nodeWithPosition.y - nodeHeight / 2,
            };

            // Update bounding box
            minX = Math.min(minX, node.position.x);
            minY = Math.min(minY, node.position.y);
            maxX = Math.max(maxX, node.position.x + nodeWidth);
            maxY = Math.max(maxY, node.position.y + nodeHeight);
        });

        // Calculate graph dimensions
        const graphWidth = maxX - minX;
        const graphHeight = maxY - minY;

        // Calculate offsets to center the graph
        const offsetX = (viewportWidth - graphWidth) / 2 - minX;
        const offsetY = (viewportHeight - graphHeight) / 2 - minY;

        // Apply offsets to center the graph
        nodes.forEach((node) => {
            node.position.x += offsetX;
            /*node.position.y += offsetY;*/
        });

        return { nodes, edges };
    };

    const ConnectWithSignalR = (workflowid) => {
        if (workflowid && workflowid !== "0" && workflowid !== 0) {
            if (connection) {
                connection
                    .stop()
                    .then(() => { })
                    .catch((err) => { });
            }
            const connect = new HubConnectionBuilder()
                .withUrl(process.env.REACT_APP_SIGNAL_R, { withCredentials: false })
                .withAutomaticReconnect()
                .build();
            connect
                .start()
                .then(() => {
                    setConnection(connect);

                    connect.send("workflowconnect", parseInt(workflowid));
                    connect.on("getsandboxworkflowupdate", (data) => {

                        if (parseInt(data.id) === parseInt(workflowid)) {

                            if (data.datatype === "tra_workflowschedulelog") {
                                let workflowpage = document.getElementById("wf_" + workflowid);

                                if (workflowpage) {
                                    let wfdata_attr = workflowpage.getAttribute("wfdata");
                                    if (wfdata_attr) {

                                        let wfdata_array = JSON.parse(wfdata_attr);
                                        let dataList1 = wfdata_array.data.dataList1;
                                        if (dataList1[0].runningworkflows && dataList1[0].runningworkflows.indexOf("[") >= 0) {
                                            let runningworkflows = JSON.parse(dataList1[0].runningworkflows);

                                            if (data.data.status.toUpperCase() === "START") {
                                                runningworkflows.unshift({
                                                    "workflowid": parseInt(workflowid),
                                                    "starton": new Date().toISOString().slice(0, -1),
                                                    "workflowulogid": data.data.workflowulogid,
                                                    "argostatus": "Running"
                                                });
                                                dataList1[0].runningworkflows = JSON.stringify(runningworkflows);
                                            }
                                            else if (data.data.status.toUpperCase() === "END") {
                                                if (dataList1[0].currentdataworkflowulogid === data.data.workflowulogid) {
                                                    BindDataByID(workflowid, data.data.workflowulogid);
                                                }
                                                else {
                                                    runningworkflows = runningworkflows.filter(
                                                        x => x.workflowulogid !== data.data.workflowulogid
                                                    );

                                                    dataList1[0].runningworkflows = runningworkflows;
                                                }
                                            }

                                            wfdata_array.data.dataList1 = dataList1;

                                            let GetWorkFlowIDData = {
                                                isValidate: true,
                                                data: {
                                                    message: "Records found",
                                                    status_code: 1,
                                                    recordcount: 0,
                                                    data: {
                                                        dataList1: wfdata_array.data.dataList1,
                                                        dataList2: wfdata_array.data.dataList2,
                                                        dataList3: wfdata_array.data.dataList3,
                                                        dataList4: wfdata_array.data.dataList4,
                                                        dataList5: [],//wfdata_array.data.dataList5,
                                                        dataList6: [],//wfdata_array.data.dataList6,
                                                    },
                                                },
                                            };

                                            BindWorkFlowDataOnUI(GetWorkFlowIDData);
                                        }
                                        else {
                                            BindDataByID(workflowid, dataList1[0].currentdataworkflowulogid ? dataList1[0].currentdataworkflowulogid : "");
                                        }
                                    }
                                    else {
                                        BindDataByID(workflowid, "");
                                    }
                                }
                                else {
                                    BindDataByID(workflowid, "");
                                }
                            } else {
                                let workflowpage = document.getElementById("wf_" + workflowid);
                                if (workflowpage) {
                                    let wfdata_attr = workflowpage.getAttribute("wfdata");
                                    if (wfdata_attr) {
                                        let wfdata_array = JSON.parse(wfdata_attr);
                                        let dataList1 = wfdata_array.data.dataList1;
                                        if (dataList1[0].currentdataworkflowulogid === data.data.workflowulogid) {
                                            let dataList2 = wfdata_array.data.dataList2;

                                            let dataList3 = wfdata_array.data.dataList3;

                                            if (data.datatype === "tra_workflowschedulemachinelog") {
                                                let checkIsExist = dataList3.filter(
                                                    (i) =>
                                                        i.workflowmachinename ===
                                                        data.data.workflowmachinename
                                                );

                                                if (checkIsExist && checkIsExist.length === 0) {
                                                    let filtermachine = allMachineDetails.filter(
                                                        (m) => m.assemblyname === data.data.assemblyname
                                                    );
                                                    //
                                                    if (filtermachine && filtermachine.length > 0) {
                                                        data.data.machinename = filtermachine[0].machinename;
                                                        data.data.machineid = filtermachine[0].machineid;
                                                    }
                                                    dataList3.push(data.data);
                                                } else {
                                                    checkIsExist[0].endon = data.data.endon;
                                                    checkIsExist[0].logdata = data.data.logdata;
                                                    checkIsExist[0].status = data.data.status;
                                                    if (data.data.stepno) {
                                                        checkIsExist[0].stepno = data.data.stepno;
                                                    }
                                                }
                                            }

                                            let dataList4 = wfdata_array.data.dataList4;

                                            if (data.datatype === "tra_machineusage") {
                                                let filtermachine = allMachineDetails.filter(
                                                    (m) => m.assemblyname === data.data.assemblyname
                                                );
                                                if (filtermachine && filtermachine.length > 0) {
                                                    data.data.machineid = filtermachine[0].machineid;
                                                }
                                                dataList4.push(data.data);
                                            }

                                            let dataList5 = [];// wfdata_array.data.dataList5;

                                            let dataList6 = [];// wfdata_array.data.dataList6;

                                            let GetWorkFlowIDData = {
                                                isValidate: true,
                                                data: {
                                                    message: "Records found",
                                                    status_code: 1,
                                                    recordcount: 0,
                                                    data: {
                                                        dataList1: dataList1,
                                                        dataList2: dataList2,
                                                        dataList3: dataList3,
                                                        dataList4: dataList4,
                                                        dataList5: dataList5,
                                                        dataList6: dataList6,
                                                    },
                                                },
                                            };

                                            BindWorkFlowDataOnUI(GetWorkFlowIDData);
                                        }
                                    }
                                    else {
                                        BindDataByID(workflowid, "");
                                    }
                                }
                                else {
                                    BindDataByID(workflowid, "");
                                }
                            }
                        }
                    });
                })
                .catch((error) => { });
        }
    };

    function fnGetWorkFlowStatus(WFData) {
        //
        let isRunning = false;
        if (WFData && WFData.length !== 0) {
            if (WFData?.[0]?.status?.toUpperCase() === "START") {
                setIsWorkFlowIsRunning(true);
                isRunning = true;
            } else {
                setIsWorkFlowIsRunning(false);
                isRunning = false;
            }
        } else {
            setIsWorkFlowIsRunning(false);
            isRunning = false;
        }
        return isRunning;
    }

    function BindWorkFlowDataOnUI(GetWorkFlowIDData) {
        if (GetWorkFlowIDData) {
            if (GetWorkFlowIDData?.isValidate) {
                let workflowpage = document.getElementById("wf_" + id);
                if (workflowpage) {
                    workflowpage.setAttribute("wfdata", "");
                }
                if (GetWorkFlowIDData.data.data.dataList1?.length > 0) {
                    let WorkFlowIsRunning = fnGetWorkFlowStatus(
                        GetWorkFlowIDData.data.data.dataList2
                    );

                    setIsWorkFlowIsRunning(WorkFlowIsRunning);

                    setFlowDetails(GetWorkFlowIDData.data.data.dataList1[0]);

                    let d =
                        GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.workflownodejson &&
                        JSON.parse(
                            GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.workflownodejson
                        );
                    let e =
                        GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.workflowedgejson &&
                        JSON?.parse(
                            GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.workflowedgejson
                        );

                    if (e && e.length > 0) {
                        e.map((ed) => ed.type = ed.target_shortname !== "loopstart-0-0-0" && ed.target_shortname !== "loopend-0-0-0" ? Edgetype : Defaultedgetype)
                    }

                    setWorkflowPopup(WorkFlowIsRunning);

                    if (WorkFlowIsRunning) {
                        if (GetWorkFlowIDData.data.data.dataList3) {
                            for (
                                let m = 0;
                                m < GetWorkFlowIDData.data.data.dataList3.length;
                                m++
                            ) {
                                const dcopy = JSON.parse(JSON.stringify(d));
                                var mdata = GetWorkFlowIDData.data.data.dataList3[m];
                                if (
                                    mdata.workflowmachinename.toUpperCase() !== "EXIT" &&
                                    mdata.workflowmachinename.toUpperCase() !== "STARTER"
                                ) {
                                    var checkIsExist = dcopy.filter(
                                        (dd) => dd.shortName === mdata.workflowmachinename
                                    );
                                    if (checkIsExist && checkIsExist.length === 0) {
                                        const samemachine = dcopy.filter(
                                            (dd) =>
                                                dd.shortName ===
                                                mdata.workflowmachinename.split("-Loop-")[0]
                                        );
                                        if (samemachine && samemachine.length > 0) {
                                            samemachine[0].id =
                                                samemachine[0].id +
                                                "_-Loop-" +
                                                mdata.workflowmachinename.split("-Loop-")[1];
                                            samemachine[0].shortName = mdata.workflowmachinename;
                                            samemachine[0].sameMachineNo = 0;
                                            //samemachine[0].typeName = mdata.machinename + '-' + mdata.workflowmachinename.replace(mdata.assemblyname, "").replace("Loop-", "");
                                            samemachine[0].typeName =
                                                commonservices.makeMachineDisplayName(
                                                    mdata.machinename,
                                                    0,
                                                    mdata.assemblyname,
                                                    mdata.workflowmachinename
                                                );

                                            d.push(samemachine[0]);
                                        }
                                    }
                                }
                            }

                            for (let ld = 0; ld < d.length; ld++) {
                                if (d[ld].shortName.toUpperCase().indexOf("-LOOP-") >= 0) {
                                    let wf =
                                        GetWorkFlowIDData?.data?.data?.dataList1?.[0]
                                            ?.workflowjson &&
                                        JSON?.parse(
                                            GetWorkFlowIDData?.data?.data?.dataList1?.[0]
                                                ?.workflowjson
                                        );

                                    if (wf && wf.dag && wf.dag.tasks) {
                                        let findmachine = wf.dag.tasks.filter(
                                            (t) =>
                                                t.name.split("-Loop-")[0] ===
                                                d[ld].shortName.split("-Loop-")[0]
                                        );
                                        if (findmachine && findmachine.length) {
                                            if (
                                                findmachine[0].fulldependencies &&
                                                findmachine[0].fulldependencies.length !== 0
                                            ) {
                                                for (
                                                    let depend = 0;
                                                    depend < findmachine[0].fulldependencies.length;
                                                    depend++
                                                ) {
                                                    let source_machinename =
                                                        findmachine[0].fulldependencies[depend] +
                                                        "-Loop-" +
                                                        d[ld].shortName.split("-Loop-")[1];
                                                    let findSourceMachine = d.filter(
                                                        (dd) => dd.shortName === source_machinename
                                                    );
                                                    if (
                                                        findSourceMachine &&
                                                        findSourceMachine.length > 0
                                                    ) {
                                                        let new_e = {
                                                            id: GenerateGUID(),
                                                            source_machineid: findSourceMachine[0].machineid,
                                                            source_machinename: findSourceMachine[0].typeName,
                                                            source_image: findSourceMachine[0].image,
                                                            source_shortname: findSourceMachine[0].shortName,
                                                            source: findSourceMachine[0].id,
                                                            target: d[ld].id,
                                                            target_machineid: d[ld].machineid,
                                                            target_machinename: d[ld].typeName,
                                                            target_image: d[ld].image,
                                                            target_shortname: d[ld].shortName,
                                                            type: Edgetype,
                                                        };
                                                        e.push(new_e);
                                                    } else {
                                                        let FirstParent_source_machinename =
                                                            findmachine[0].fulldependencies[depend];

                                                        let FirstParent_findSourceMachine = d.filter(
                                                            (dd) =>
                                                                dd.shortName === FirstParent_source_machinename
                                                        );
                                                        if (
                                                            FirstParent_findSourceMachine &&
                                                            FirstParent_findSourceMachine.length > 0
                                                        ) {
                                                            let new_e = {
                                                                id: GenerateGUID(),
                                                                source_machineid:
                                                                    FirstParent_findSourceMachine[0].machineid,
                                                                source_machinename:
                                                                    FirstParent_findSourceMachine[0].typeName,
                                                                source_image:
                                                                    FirstParent_findSourceMachine[0].image,
                                                                source_shortname:
                                                                    FirstParent_findSourceMachine[0].shortName,
                                                                source: FirstParent_findSourceMachine[0].id,
                                                                target: d[ld].id,
                                                                target_machineid: d[ld].machineid,
                                                                target_machinename: d[ld].typeName,
                                                                target_image: d[ld].image,
                                                                target_shortname: d[ld].shortName,
                                                                type: Edgetype,
                                                            };
                                                            e.push(new_e);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        let loopend = d.filter(
                            (m) => m.template.toUpperCase() === "LOOPEND-0-0-0"
                        );

                        if (loopend && loopend.length > 0) {
                            let wf =
                                GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.workflowjson &&
                                JSON?.parse(
                                    GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.workflowjson
                                );
                            if (wf && wf.dag && wf.dag.tasks) {
                                let findmachine = wf.dag.tasks.filter(
                                    (t) => t.template.toUpperCase() === "LOOPEND-0-0-0"
                                );
                                if (findmachine && findmachine.length) {
                                    if (
                                        findmachine[0].fulldependencies &&
                                        findmachine[0].fulldependencies.length > 0
                                    ) {
                                        for (
                                            let el = 0;
                                            el < findmachine[0].fulldependencies.length;
                                            el++
                                        ) {
                                            let depmachine = d.filter(
                                                (t) =>
                                                    t.shortName.split("-Loop-")[0] ===
                                                    findmachine[0].fulldependencies[el].split("-Loop-")[0]
                                            );
                                            if (depmachine && depmachine.length > 0) {
                                                for (let nel = 0; nel < depmachine.length; nel++) {
                                                    let new_e = {
                                                        id: GenerateGUID(),
                                                        source_machineid: 0,
                                                        source_machinename: "",
                                                        source_image: "",
                                                        source_shortname: "",
                                                        source: depmachine[nel].id,
                                                        target: loopend[0].id,
                                                        target_machineid: 0,
                                                        target_machinename: "",
                                                        target_image: "",
                                                        target_shortname: "",
                                                        type: Edgetype,
                                                    };
                                                    e.push(new_e);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        let { nodes: layoutedNodes, edges: layoutedEdges } =
                            getLayoutedElements(d, e);

                        layoutedNodes = layoutedNodes?.map((item) => ({
                            ...item,
                            data: {
                                ...item?.data,
                                label: CreateModel(
                                    item?.image,
                                    item?.id,
                                    item?.typeName,
                                    item.shortName,
                                    WorkFlowIsRunning,
                                    item?.sameMachineNo,
                                    GetWorkFlowIDData?.data?.data?.dataList3,
                                    GetWorkFlowIDData?.data?.data?.dataList2,
                                    GetWorkFlowIDData.data.data.dataList1[0]
                                ),
                            },
                        }));

                        //-Loop-
                        layoutedNodes = layoutedNodes?.map((item) => ({
                            ...item,
                            className:
                                fnGetMachineStatus(
                                    item.shortName,
                                    GetWorkFlowIDData.data.data.dataList3,
                                    GetWorkFlowIDData.data.data.dataList2
                                ) +
                                " " +
                                (item.id.indexOf("-Loop-") >= 0 ? "logical" : ""),
                        }));

                        if (WorkFlowIsRunning) {
                            if (workflowpage) {
                                workflowpage.setAttribute(
                                    "wfdata",
                                    JSON.stringify(GetWorkFlowIDData.data)
                                );
                            }
                            var runningMachineData = layoutedNodes.filter(
                                (i) => i.className.indexOf("start") >= 0
                            );
                            if (
                                runningMachineData &&
                                runningMachineData !== null &&
                                runningMachineData.length > 0
                            ) {
                                handleNodeClick(
                                    "",
                                    runningMachineData[0],
                                    WorkFlowIsRunning,
                                    GetWorkFlowIDData.data.data.dataList3,
                                    GetWorkFlowIDData.data.data.dataList4
                                );
                            }
                        }

                        setNodes(layoutedNodes);
                        setEdges(layoutedEdges);
                    } else {
                        d = d?.map((item) => ({
                            ...item,
                            data: {
                                ...item?.data,
                                label: CreateModel(
                                    item?.image,
                                    item?.id,
                                    item?.typeName,
                                    item.shortName,
                                    WorkFlowIsRunning,
                                    item?.sameMachineNo,
                                    GetWorkFlowIDData?.data?.data?.dataList3,
                                    GetWorkFlowIDData?.data?.data?.dataList2,
                                    GetWorkFlowIDData.data.data.dataList1[0]
                                ),
                            },
                        }));
                        d = d?.map((item) => ({
                            ...item,
                            className: fnGetMachineStatus(
                                item.shortName,
                                GetWorkFlowIDData.data.data.dataList3,
                                GetWorkFlowIDData.data.data.dataList2
                            ),
                            outputdata: fnGetMachineOutputData(
                                item.shortName,
                                GetWorkFlowIDData.data.data.dataList3
                            )
                        }));
                        setNodes(d);
                        setEdges(e);
                    }

                    if (GetWorkFlowIDData.data.data.dataList1[0]?.workflowjson) {
                        let _workflowjson = JSON.parse(GetWorkFlowIDData.data.data.dataList1[0]?.workflowjson)
                        if (_workflowjson?.loop_sample_data) {
                            let _loop_sample_data = JSON.parse(_workflowjson?.loop_sample_data);
                            setLoop_sample_data(_loop_sample_data);
                        }
                        else {
                            setLoop_sample_data([]);
                        }
                    }
                    else {
                        setLoop_sample_data([]);
                    }


                    setFlowName(GetWorkFlowIDData.data.data.dataList1[0]?.workflowname);
                    let _parametersforworkflow = [];
                    if (GetWorkFlowIDData.data.data.dataList1[0]?.parametersforworkflow) {
                        _parametersforworkflow = JSON.parse(GetWorkFlowIDData.data.data.dataList1[0]?.parametersforworkflow);
                    }
                    setParametersForWorkflow(_parametersforworkflow)
                    setParallelism(GetWorkFlowIDData.data.data.dataList1[0]?.parallelism);
                    setRetrystrategy(GetWorkFlowIDData.data.data.dataList1[0]?.retrystrategy);
                    setEksnodegroup(GetWorkFlowIDData.data.data.dataList1[0]?.eksnodegroup);

                    setWorkFlowMachineStatus(GetWorkFlowIDData.data.data.dataList3);
                    setWorkFlowMachineUse(GetWorkFlowIDData.data.data.dataList4);
                    setWorkFlowStatus(GetWorkFlowIDData.data.data.dataList2);
                }

            }
        }
    }

    const { leftOffset, rightOffset } = calculateOffsets();

    useLayoutEffect(() => {
        getMachineListBySubscriberId();
    }, []);

    useEffect(() => {
        if (id) {
            getProjectTermList();
        }
    }, [Userdata, EncID, id]);

    useEffect(() => {
        if (divRef.current) {
            divRef.current.scrollTop = divRef.current.scrollHeight;
        }
    }, [WorkFlowMachineStatus]);

    useEffect(() => {
        BindWorkFlowDataOnUI(GetWorkFlowIDData);
        return () => {
            dispatch(setSandboxGetWorkFlowByID());
        };
    }, [GetWorkFlowIDData]);

    useEffect(() => {
        if (IsWorkFlowIsRunning) {
            setActiveSidePanel(false);
            setActiveRightSidePanel("summary");
            setActiveRightSidePinnedPanel("summary");
        }
    }, [IsWorkFlowIsRunning]);

    useEffect(() => {
        if (id && allMachineDetails) {
            BindDataByID(id, "");
        }
    }, [allMachineDetails, id]);

    useEffect(() => {
        if (id && allMachineDetails) {
            if (connection) {
                connection
                    .stop()
                    .then(() => { })
                    .catch((err) => { });
            }
            ConnectWithSignalR(id);
        }
    }, [id, allMachineDetails]);

    const _DataProfileBlankObj = {
        SelfMachine: {
            outputfilename: "",
            inputsamplefile: "",
            machineid: 0,
            machinename: "",
            outputsamplefile: "",
            versionnumber: "",
            keypaths: [],
            json: null,
            input_data: "",
            machinelogo: "",
        },
        ParentMachine: [],
    };

    const [DataProfileDetails, setDataProfileDetails] = useState(_DataProfileBlankObj);
    const [IsOpenDataProfileConfiguration, setIsOpenDataProfileConfiguration] = useState(false);
    const [MachineOutputPopupData, setMachineOutputPopupData] = useState({
        IsOpen: false,
        JsonData: null,
        MachineName: ""
    });
    const [MachineLogPopupData, setMachineLogPopupData] = useState({
        IsOpen: false,
        MachineULogID: ""
    });
    const FnOpenDataProfileMappingPopup = async (id) => {
        let configValidation = handleConfigValidation();
        if (configValidation?.nodeErrorArr?.length > 0) {
            setFlowLoader(false);
            setNodes(configValidation?.updatedNodes);
            handleNodeClick(
                "",
                configValidation?.nodeErrorArr?.[0],
                IsWorkFlowIsRunning,
                WorkFlowMachineStatus,
                WorkFlowMachineUse
            );
            return;
        }

        setDataProfileDetails(_DataProfileBlankObj);
        let NoOfParent = edges.filter((item) => item.target === id);
        if (NoOfParent && NoOfParent.length > 0) {
            let IsLoopStart = NoOfParent.filter((item) => item.source_shortname === "loopstart-0-0-0");
            if (IsLoopStart && IsLoopStart.length > 0) {
                let LoopStart_NoOfParent = edges.filter((item) => item.target === IsLoopStart[0].source);
                if (LoopStart_NoOfParent && LoopStart_NoOfParent.length > 0) {
                    LoopStart_NoOfParent.map((LSP) => NoOfParent.push(LSP));
                }
            }
            let ParentMachine = [];
            let SelfMachine = _DataProfileBlankObj.SelfMachine;
            let dataprofile_query = "";
            let condition_list = "";
            for (let i = 0; i < NoOfParent.length; i++) {
                if (i === 0) {
                    if (
                        NoOfParent[i].target_machineid &&
                        NoOfParent[i].target_shortname
                    ) {
                        let objmachine = allMachineList.dataList1.filter(
                            (m) => m.machineid === parseInt(NoOfParent[i].target_machineid)
                        );

                        if (objmachine && objmachine.length !== 0) {
                            let MachineName = commonservices.makeMachineDisplayName(
                                objmachine[0].machinename,
                                0,
                                objmachine[0].assemblyname,
                                NoOfParent[i].target_shortname
                            );

                            let outputdata = "";
                            let Fnode = nodes.filter((n) => n.shortName === NoOfParent[i].target_shortname);
                            if (Fnode && Fnode.length > 0) {
                                if (Fnode[0].outputdata) {
                                    outputdata = Fnode[0].outputdata;
                                }
                            }

                            SelfMachine.outputfilename = NoOfParent[i].target_shortname + ".json";
                            SelfMachine.machineid = parseInt(NoOfParent[i].target_machineid);
                            SelfMachine.machinename = MachineName;
                            SelfMachine.outputsamplefile = objmachine[0].outputsamplefile;
                            SelfMachine.versionnumber = objmachine[0].versionnumber;
                            SelfMachine.inputsamplefile = objmachine[0].inputsamplefile;
                            SelfMachine.input_data = null;
                            SelfMachine.machinelogo = objmachine[0].machinelogo;
                            SelfMachine.outputdata = outputdata;

                            let SelfNode = nodes.filter((f) => f.id === id);
                            if (SelfNode && SelfNode.length > 0) {
                                let objForParaValue = {};

                                dataprofile_query = SelfNode[0].dataprofile_query;
                                condition_list = SelfNode[0].condition_list;
                                SelfNode[0].configData?.forEach((configItem) => {
                                    let valueForConfig = "";
                                    if (configItem?.value) {
                                        valueForConfig = configItem?.value;
                                    }
                                    if (configItem?.paratype === "Number" && configItem?.value) {
                                        valueForConfig = parseInt(configItem?.value);
                                    }
                                    if (configItem?.paratype === "Decimal" && configItem?.value) {
                                        valueForConfig = parseFloat(configItem?.value);
                                    }
                                    if (configItem?.paratype === "Json" && configItem?.value) {
                                        valueForConfig = JSON.parse(configItem?.value);
                                    }
                                    objForParaValue = {
                                        ...objForParaValue,
                                        [configItem?.parakey]: valueForConfig,
                                    };
                                });
                                SelfMachine.input_data = objForParaValue;
                            }
                        }
                    }
                }
                if (NoOfParent[i].source_machineid && NoOfParent[i].source_shortname) {
                    let checkDub = ParentMachine.filter(
                        (d) => d.outputfilename === NoOfParent[i].source_shortname + ".json"
                    );
                    if (checkDub.length === 0) {
                        let objmachine = allMachineList.dataList1.filter(
                            (m) => m.machineid === parseInt(NoOfParent[i].source_machineid)
                        );
                        if (objmachine && objmachine.length !== 0) {
                            let MachineName = commonservices.makeMachineDisplayName(
                                objmachine[0].machinename,
                                0,
                                objmachine[0].assemblyname,
                                NoOfParent[i].source_shortname
                            );

                            let outputdata = "";
                            let Fnode = nodes.filter((n) => n.shortName === NoOfParent[i].source_shortname);
                            if (Fnode && Fnode.length > 0) {
                                if (Fnode[0].outputdata) {
                                    outputdata = Fnode[0].outputdata;
                                }
                            }

                            ParentMachine.push({
                                outputfilename: NoOfParent[i].source_shortname + ".json",
                                machineid: parseInt(NoOfParent[i].source_machineid),
                                machinename: MachineName,
                                outputsamplefile: objmachine[0].outputsamplefile,
                                inputsamplefile: objmachine[0].inputsamplefile,
                                versionnumber: objmachine[0].versionnumber,
                                input_data: "",
                                machinelogo: objmachine[0].machinelogo,
                                outputdata: outputdata
                            });
                        }
                    }
                }
            }
            if (SelfMachine.input_data && SelfMachine.input_data !== null && SelfMachine.input_data !== undefined && Object.keys(SelfMachine.input_data).length !== 0) {
                setDataProfileDetails({
                    SelfMachine: SelfMachine,
                    ParentMachine: ParentMachine,
                    nodeid: id,
                    dataprofile_query: dataprofile_query,
                    condition_list: condition_list
                });
                setIsOpenDataProfileConfiguration(true);
            }
        }
    };
    const fnSetDataProfiling = (dataprofile_query, DataProfileDetails) => {
        let SelfNode = nodes.filter((f) => f.id === DataProfileDetails.nodeid);
        if (SelfNode && SelfNode.length > 0) {
            SelfNode[0].dataprofile_query = dataprofile_query;
        }
        setNodes(nodes);
    };
    const fnSetCondition = (condition_list, DataProfileDetails) => {
        let SelfNode = nodes.filter((f) => f.id === DataProfileDetails.nodeid);
        if (SelfNode && SelfNode.length > 0) {
            SelfNode[0].condition_list = condition_list;
        }
        setNodes(nodes);
    };
    const targetConfig = useRef(null);
    const [showConfigPopup, setShowConfigPopup] = useState(false);
    const handleShowConfigPopup = (e) => {
        if (document.getElementById("body").classList.contains("popup-is-open")) {
            document.getElementById("body").classList.remove("popup-is-open");
        } else {
            document.getElementById("body").classList.add("popup-is-open");
        }
        setShowConfigPopup(!showConfigPopup);
    };
    const WorkflowConfigSave = (data) => {
        setParametersForWorkflow(data.parametersforworkflow ? data.parametersforworkflow : [])
        handleShowConfigPopup();
    };

    const [ConvertWorkflowConfirmation, setConvertWorkflowConfirmation] = useState(false);
    const [SandboxConvertType, setSandboxConvertType] = useState("New Workflow");
    const [SandboxConvertWorkflowName, setSandboxConvertWorkflowName] = useState("");
    const [SandboxConvertWorkflowID, setSandboxConvertWorkflowID] = useState(0);
    const [SandboxConvertValidationMessage, setSandboxConvertValidationMessage] = useState("");

    const fnConvertSandboxToWorkflow = async () => {
        let checkisvalid = false;
        setSandboxConvertValidationMessage("");
        if (SandboxConvertType === "New Workflow") {
            if (SandboxConvertWorkflowName) {
                if (API_URL.BASEURL.includes("beta")) {
                    if (SandboxConvertWorkflowName.startsWith("beta-")) {
                        checkisvalid = true;
                    }
                    else {
                        setSandboxConvertValidationMessage("Workflow name start with beta-");
                    }
                }
                else {
                    checkisvalid = true;
                }

                if (SandboxConvertWorkflowName.toLowerCase().indexOf("sandbox") >= 0) {
                    setSandboxConvertValidationMessage("The keyword 'SANDBOX' is not allowed in workflow names.");
                    checkisvalid = false;
                }
            }
            else {
                setSandboxConvertValidationMessage("This Field is a required field");
            }
        }
        else {
            if (SandboxConvertWorkflowID && parseInt(SandboxConvertWorkflowID) > 0) {
                checkisvalid = true;
            }
            else {
                setSandboxConvertValidationMessage("This Field is a required field");
            }
        }
        if (checkisvalid) {
            setConvertWorkflowConfirmation(false);
            handleWorkFlowSave("SAVE AND CONVERT AS WORKFLOW", "Entire Workflow");
        }
    };

    const ConvertWorkflowConfirmationClose = () => {
        setConvertWorkflowConfirmation(false);
        setSandboxConvertType("New Workflow");
        setSandboxConvertWorkflowName("");
        setSandboxConvertWorkflowID(0);

    };

    const handleWorkFlowSaveRef = useRef(null);

    const handleWorkFlowSave = async (ActionType, RunMachine) => {

        if (edges?.length > 0 && nodes?.length > 0 && flowName !== "") {

            setFlowLoader(true);
            let configValidation = handleConfigValidation();
            if (configValidation?.nodeErrorArr?.length > 0) {
                setFlowLoader(false);
                setNodes(configValidation?.updatedNodes);
                handleNodeClick(
                    "",
                    configValidation?.nodeErrorArr?.[0],
                    IsWorkFlowIsRunning,
                    WorkFlowMachineStatus,
                    WorkFlowMachineUse
                );
                return;
            }
            let workFlowJson = createWorkflowJson();


            if (workFlowJson) {

                const oversizedArgumentMachines = getTaskArgumentsOversizeMachines(
                    workFlowJson?.groupingJson?.dag?.tasks
                );

                if (oversizedArgumentMachines.length > 0) {
                    setFlowLoader(false);
                    toast.error(
                        "Do not enter parameter value size greater than 64KB in machine(s):\n" +
                        oversizedArgumentMachines.join("\n")
                    );
                    return;
                }

                if (workFlowJson.IsAnyInvalidSubWorkflow && workFlowJson.IsAnyInvalidSubWorkflow.length > 0) {
                    let imname = "";
                    for (let ii = 0; ii < workFlowJson.IsAnyInvalidSubWorkflow.length; ii++) {
                        imname = imname + workFlowJson.IsAnyInvalidSubWorkflow[ii].name + "\n";
                    }
                    setFlowLoader(false);
                    toast.error("Below workflow are not valid. \n" + imname);
                    return;
                }

                if (workFlowJson?.NoOfParentNode !== 1) {
                    setFlowLoader(false);
                    toast.error("Add One Parent Only");
                    return;
                }

                let groupingJson = workFlowJson?.groupingJson;

                if (RunMachine.toUpperCase() !== "ENTIRE WORKFLOW") {
                    let _RunMachingFilter = groupingJson.dag.tasks.filter(task => task.template === RunMachine);
                    if (_RunMachingFilter && _RunMachingFilter.length > 0) {
                        groupingJson.dag.tasks = JSON.parse(JSON.stringify(_RunMachingFilter, null, 2).replaceAll("{{inputs.parameters.count}}", "0"));
                        groupingJson.dag.tasks.map((item) => item.dependencies = []);
                    }
                }

                let payload = {
                    "WorkFlow.workflowsandboxid": id,
                    "WorkFlow.description": "",
                    "WorkFlow.tag": "",
                    "WorkFlow.workflowname": flowName ? flowName?.trim() : flowName,
                    "WorkFlow.workflownodejson": JSON.stringify(nodes),
                    "WorkFlow.workflowedgejson": JSON.stringify(edges),
                    "WorkFlow.workflowjson": JSON.stringify(groupingJson),
                    "WorkFlow.parametersforworkflow": JSON.stringify(parametersforworkflow ? parametersforworkflow : []),
                    "WorkFlow.parallelism": 1,
                    "WorkFlow.retrystrategy": 1,
                    "WorkFlow.nodegroup": eksnodegroup ? eksnodegroup : "",
                    "WorkflowMachineFiles": workFlowJson.MachinesFiles,
                    "WorkFlow.actiontype": ActionType,
                    "WorkFlow.sandboxconverttype": SandboxConvertType,
                    "WorkFlow.sandboxconvertworkflowname": SandboxConvertWorkflowName,
                    "WorkFlow.sandboxconvertworkflowid": SandboxConvertWorkflowID,
                };

                if (ActionType === "SAVE AND RUN") {
                    setIsWorkFlowIsRunning(true);
                }

                dispatch(SandboxWorkFlowSave(payload)).then((response) => {
                    let data = commonservices.bodyEncryption(
                        `${response?.payload?.data?.data?.workFlow?.workflowsandboxid}`
                    );
                    if (response?.payload?.isValidate) {
                        setFlowLoader(false);
                        setTrackState(false);
                        if (ActionType === "SAVE AND CONVERT AS WORKFLOW") {

                            let dataworkflowid = commonservices.bodyEncryption(
                                `${response?.payload?.data?.data?.workFlow?.sandboxconvertworkflowid}?v=0&r=wc`,
                            );

                            navigate(`/flow-new/${dataworkflowid}`, {
                                state: {
                                    isViewMode: false
                                },
                            });
                        }
                        else {
                            navigate(`/sandbox/${data}`);
                            BindDataByID(response?.payload?.data?.data?.workFlow?.workflowsandboxid, "");
                        }
                    }
                    if (!response?.payload?.isValidate) {
                        setFlowLoader(false);
                        setTrackState(false);
                        setIsWorkFlowIsRunning(false);
                    }
                });

            } else {
                setFlowLoader(false);
                setIsWorkFlowIsRunning(false);
            }

        } else {
            setFlowLoader(false);
            toast.error("Please provide proper data for save");
        }
    };

    handleWorkFlowSaveRef.current = handleWorkFlowSave;

    const [WorkflowListData, setWorkflowListData] = useState([]);

    const getWorkFlowList = () => {
        if (WorkflowListData && WorkflowListData.length > 0) {
            setConvertWorkflowConfirmation(true);
        }
        else {
            dispatch(WorkflowGetListForDDL({
                searchText: "",
            }))?.then((response) => {
                setConvertWorkflowConfirmation(true);
                if (response?.payload?.isValidate) {
                    if (response?.payload?.data?.data?.length > 0) {
                        setWorkflowListData(response?.payload?.data?.data);
                    }
                }
            });
        }
    };

    return (
        <>
            {FlowLoader && <MainpageLoader />}
            <div
                className="flow-page-new projects-view-page-main having-small-blue-bg flow-chart-wrapper-main-content"
                id={"wf_" + id}
            >
                <Container className="flow-chart-container">
                    <div className="flow-chart-container-inner">
                        <div className="top-bot-section drag-drop-page">
                            <div className="d-flex align-items-center gap-3">
                                <h6 className="d-flex align-items-center gap-1">
                                    <img
                                        src={homeImage}
                                        alt="home"
                                        title="home"
                                        style={{ cursor: "pointer", marginBottom: "3px" }}
                                        onClick={() => {
                                            if (!trackState) {
                                                navigate("/dashboard");
                                            }
                                        }}
                                    />
                                    <span style={{ fontWeight: "400", color: "#666666" }}>
                                        {" | "}
                                    </span>
                                    <span>Sandbox</span>
                                </h6>

                                <div className="d-flex align-items-center gap-2 ">
                                    <div className="position-relative tourWorkflowName">
                                        <input
                                            disabled={true}
                                            className={"common-select-disabled save-main-input"}
                                            type="text"
                                            title={flowName}
                                            value={flowName}
                                            placeholder="Sandbox Workflow Name"
                                        />
                                    </div>
                                </div>
                                <Dropdown className="public-private-dropdown ">
                                    <Dropdown.Toggle
                                        id="isprivate"
                                        className="tourWorkflowButtons"
                                        style={{
                                            backgroundColor: "#0461BB",
                                            color: "#dcecf9",
                                            border: "1px solid #2490d2"
                                        }}
                                    >
                                        Save
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => { handleWorkFlowSave("SAVE", "Entire Workflow"); }}>
                                            <h6>Save</h6>
                                            <p>
                                                Sava as sandbox workflow.
                                            </p>
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => { getWorkFlowList(); }}>
                                            <h6>Convert As Workflow</h6>
                                            <p>
                                                Convert the selected sandbox into a workflow,
                                                creating as new workflow or replace in existing workflow.
                                            </p>
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                                {
                                    !IsWorkFlowIsRunning &&
                                    <button className="green-btn run-btn-dimension" onClick={() => { handleWorkFlowSave("SAVE AND RUN", "Entire Workflow"); }}>
                                        <span>Run Now</span>
                                        <img src={playicon} alt="playicon" />
                                    </button>
                                }
                            </div>
                            <div className="top-bot-right-section">
                                <div
                                    className={
                                        supportShowModel
                                            ? "filtering-main overlay-isopen tourWorkflowSupport gap-1 d-flex cursor-pointer"
                                            : "filtering-main tourWorkflowSupport gap-1 d-flex cursor-pointer"
                                    }
                                    id="Support-usage-three"
                                    onClick={() => setSupportShowModel(!supportShowModel)}
                                >
                                    <img src={supportmodule} alt="supportmodule" />
                                    <span>Support</span>
                                </div>
                                <div
                                    ref={targetConfig}
                                    id="add-project"
                                    className={
                                        showConfigPopup
                                            ? "filtering-main position-relative  overlay-isopen tourWorkflowConfig gap-1 d-flex cursor-pointer"
                                            : "filtering-main position-relative tourWorkflowConfig gap-1 d-flex cursor-pointer"
                                    }
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowConfigPopup(!showConfigPopup);
                                        handleShowConfigPopup();
                                    }}
                                >
                                    <img src={configmodule} alt="configmodule" />
                                    <span>Config </span>
                                </div>

                                {showConfigPopup && (
                                    <Overlay
                                        target={targetConfig.current}
                                        show={showConfigPopup}
                                        placement="bottom-end"
                                    >
                                        {(props) => (
                                            <Tooltip id="overlay-example" {...props}>
                                                <ConfigModel
                                                    workspaceList={[]}
                                                    hooktype="trigger-run-workflow"
                                                    associationid={id}
                                                    associationtype="Workflow"
                                                    handleshowPopup={handleShowConfigPopup}
                                                    isViewMode={false}
                                                    workflowdata={{ parallelism: parallelism, retrystrategy: retrystrategy, workspaceInput: [], parametersforworkflow: parametersforworkflow && parametersforworkflow.length > 0 ? parametersforworkflow : [{ "name": "", "value": "", "isvalid": "", "isvalidName": "" }], eksnodegroup: eksnodegroup }}
                                                    configurationsave={WorkflowConfigSave}
                                                    viewOption={"Parameters"}
                                                />
                                            </Tooltip>
                                        )}
                                    </Overlay>
                                )}


                                <div
                                    className="filtering-main-close"
                                    id="close"
                                    onClick={(e) => {
                                        if (!trackState) {
                                            if (connection) {
                                                connection
                                                    .stop()
                                                    .then(() => { })
                                                    .catch((err) => { });
                                            }
                                            navigate("/sandboxs");
                                        }
                                    }}
                                >
                                    <img src={closeImage} alt="close" />
                                </div>

                            </div>
                        </div>
                    </div>
                </Container>
                <div className="container">
                    {/* Left Panel */}
                    <div
                        className={`panel left-panel ${activeSidePanel ? "open" : "closed"
                            }`}
                    >
                        <div className="panel-header d-flex align-items-center justify-content-between drag-drop-page-side-panel-header gap-2">
                            <h6
                                className="tourWorkflowMachines"
                                onClick={() => {
                                    if (!IsWorkFlowIsRunning) {
                                        handleSidepanelClick();
                                    }
                                }}
                            >
                                <span>Machines</span>
                            </h6>{" "}
                            {activeSidePanel && (
                                <div className="search-pin-box">
                                    {" "}
                                    <div className="header-search-input">
                                        <InputGroup>
                                            <InputGroup.Text id="basic-addon1">
                                                <img
                                                    src={searchicon}
                                                    alt="searchicon"
                                                    className="cursor-pointer"
                                                />
                                            </InputGroup.Text>
                                            <Form.Control
                                                placeholder="Search Machines"
                                                aria-label="Search"
                                                aria-describedby="basic-addon1"
                                                onChange={(e) => setSearchInput(e.target.value)}
                                            />
                                        </InputGroup>
                                    </div>
                                    <div>
                                        <img
                                            style={{ width: "18px" }}
                                            src={activeSidePanelPinned ? pinned : unpinned}
                                            alt="analatics"
                                            onClick={() =>
                                                activeSidePanelPinned
                                                    ? setActiveSidePanelPinned(false)
                                                    : setActiveSidePanelPinned(true)
                                            }
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="panel-content">
                            <div className="drag-drop-page-side-panel-accordion">
                                {machineDataLoading ? (
                                    <div>
                                        <Loader type={LoaderType.Line} count={8} />
                                    </div>
                                ) : machineList ? (
                                    <>
                                        <div className="drag-drop-page-side-panel-accordion-all">
                                            {Object?.entries(machineList)?.map(
                                                ([key, value], index) => {
                                                    return (
                                                        <>
                                                            <Accordion defaultActiveKey={["0"]} alwaysOpen>
                                                                <Accordion.Item eventKey={index?.toString()}>
                                                                    <Accordion.Header>
                                                                        {key +
                                                                            ` (${searchInput
                                                                                ? value?.filter((machineItem) =>
                                                                                    machineItem?.machinename
                                                                                        .toLowerCase()
                                                                                        .includes(
                                                                                            searchInput.toLowerCase()
                                                                                        )
                                                                                ).length
                                                                                : value?.length
                                                                            })`}
                                                                    </Accordion.Header>
                                                                    <Accordion.Body>
                                                                        <div className="draggable-items-container">
                                                                            {value?.length > 0 ? (
                                                                                value.some((machineItem) =>
                                                                                    machineItem?.machinename
                                                                                        .toLowerCase()
                                                                                        .includes(searchInput.toLowerCase())
                                                                                ) ? (
                                                                                    value.map((machineItem) => {
                                                                                        return (
                                                                                            <>
                                                                                                {machineItem?.machinename
                                                                                                    .toLowerCase()
                                                                                                    .includes(
                                                                                                        searchInput.toLowerCase()
                                                                                                    ) && (
                                                                                                        <div
                                                                                                            title={
                                                                                                                machineItem?.machinename
                                                                                                            }
                                                                                                            key={machineItem?.machineid}
                                                                                                            className="draggable-item"
                                                                                                            onDragStart={(event) => {
                                                                                                                if (IsWorkFlowIsRunning) {
                                                                                                                    toast.error(
                                                                                                                        "You are not able to modify workflow when the workflow is running."
                                                                                                                    );
                                                                                                                } else {
                                                                                                                    event.dataTransfer.setData(
                                                                                                                        "application/reactflow",
                                                                                                                        JSON.stringify(
                                                                                                                            machineItem
                                                                                                                        )
                                                                                                                    );
                                                                                                                }
                                                                                                            }}
                                                                                                            draggable={
                                                                                                                !IsWorkFlowIsRunning
                                                                                                            }
                                                                                                        >
                                                                                                            <div>
                                                                                                                <div className="align-items-start justify-content-between d-flex">
                                                                                                                    <span>
                                                                                                                        <img
                                                                                                                            src={
                                                                                                                                machineItem?.machinelogo ||
                                                                                                                                DemoLogo
                                                                                                                            }
                                                                                                                            alt={
                                                                                                                                machineItem?.machinename
                                                                                                                            }
                                                                                                                            style={{
                                                                                                                                height: "28px",
                                                                                                                                width: "28px",
                                                                                                                                objectFit:
                                                                                                                                    "contain",
                                                                                                                            }}
                                                                                                                            onError={(e) => {
                                                                                                                                e.target.onerror =
                                                                                                                                    null; // Prevents infinite loop in case fallback also fails
                                                                                                                                e.target.src =
                                                                                                                                    DemoLogo;
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    </span>
                                                                                                                    {machineItem?.isdisplayversionnumber ===
                                                                                                                        1 && (
                                                                                                                            <span className={`green-badge versionmachine ${machineItem?.versionnumber} ${key.replace(" ", "")}`}>
                                                                                                                                {machineItem?.versionnumber
                                                                                                                                    ? machineItem?.versionnumber
                                                                                                                                    : ""}
                                                                                                                            </span>
                                                                                                                        )}
                                                                                                                </div>
                                                                                                                <p
                                                                                                                    style={{
                                                                                                                        fontSize: "10px",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {
                                                                                                                        machineItem?.machinename
                                                                                                                    }
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}
                                                                                            </>
                                                                                        );
                                                                                    })
                                                                                ) : (
                                                                                    <div className="text-center no-machines-found w-100">
                                                                                        No Data Found
                                                                                    </div>
                                                                                )
                                                                            ) : (
                                                                                <div className="text-center no-machines-found w-100">
                                                                                    No Data Found
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </Accordion.Body>
                                                                </Accordion.Item>
                                                            </Accordion>
                                                        </>
                                                    );
                                                }
                                            )}
                                        </div>

                                        <div className="workflow-notdata">
                                            <div className="more-machine-main d-flex">
                                                <div className="more-machine-icon mr-2">
                                                    <img src={buymoremachine} alt="buymoremachine" />
                                                </div>
                                                <div className="more-machine-detail">
                                                    <h3>Buy More Machines</h3>
                                                    <p>
                                                        Boost your data processing power adding more
                                                        machines for faster & scalable insights.
                                                    </p>
                                                </div>
                                            </div>
                                            <button
                                                onClick={() => navigate("/marketplace")}
                                                disabled={FlowLoader}
                                                className="blue-btn  mt-3"
                                            >
                                                Explore Marketplace
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    <div className="not-machine-aval">
                                        <img src={notmachineavaliable} alt="notmachineavaliable" />
                                        <h2>No Machines Available</h2>
                                        <p>
                                            It looks like you don’t have any machines yet. Browse our
                                            marketplace to find the perfect machine for your needs.
                                        </p>
                                        <button
                                            onClick={() => navigate("/marketplace")}
                                            disabled={FlowLoader}
                                            className="blue-btn w-auto mt-3 "
                                        >
                                            Explore Marketplace
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Right Panel */}
                    <div className="right-panel-sticky-menu">
                        <h6
                            className={
                                activeRightSidePanel === "machine"
                                    ? "tourWorkflowMachineSetup cursor-pointer right-panel-sticky-menu-Active"
                                    : "tourWorkflowMachineSetup cursor-pointer"
                            }
                            onClick={() => {
                                if (activeRightSidePanel === "machine") {
                                    setActiveRightSidePanel("sm-panel");
                                } else {
                                    setActiveRightSidePanel("machine");
                                }
                            }}
                        >
                            Machine Setup
                        </h6>
                        <h6
                            className={
                                activeRightSidePanel === "summary"
                                    ? "tourWorkflowMachineSetup cursor-pointer right-panel-sticky-menu-Active"
                                    : "tourWorkflowMachineSetup cursor-pointer"
                            }
                            onClick={() => {
                                if (activeRightSidePanel === "summary") {
                                    setActiveRightSidePanel("sm-panel");
                                } else {
                                    setActiveRightSidePanel("summary");
                                }
                            }}
                        >
                            Status
                        </h6>
                        <h6
                            className={
                                activeRightSidePanel === "costSummary"
                                    ? "tourWorkflowMachineSetup cursor-pointer right-panel-sticky-menu-Active"
                                    : "tourWorkflowMachineSetup cursor-pointer"
                            }
                            onClick={() => {
                                if (activeRightSidePanel === "costSummary") {
                                    setActiveRightSidePanel("sm-panel");
                                } else {
                                    setActiveRightSidePanel("costSummary");
                                }
                            }}
                        >
                            Cost Summary
                        </h6>
                    </div>
                    <div
                        className={`panel right-panel ${activeRightSidePanel !== "sm-panel" ? "open" : "closed"
                            }`}
                    >
                        {activeRightSidePanel === "summary" && (
                            <WorkFlowStatusModel
                                NetworkUsageChart={NetworkUsageChart}
                                MemoryUsageChart={MemoryUsageChart}
                                CPUUsageChart={CPUUsageChart}
                                id={id}
                                NewMachineInfo={NewMachineInfo}
                                FnForsetIsWorkFlowIsRunning={setIsWorkFlowIsRunning}
                                IsWorkFlowIsRunning={IsWorkFlowIsRunning}
                                FnForsetActiveRightSidePanel={setActiveRightSidePanel}
                                activeRightSidePinnedPanel={activeRightSidePinnedPanel}
                                FnForsetActiveRightSidePinnedPanel={
                                    FnForsetActiveRightSidePinnedPanel
                                }
                                flowDetails={flowDetails}
                                BindDataByID={BindDataByID}
                                FunForsetActiveSidePanelPinned={FunForsetActiveSidePanelPinned}
                                FunForsetActiveSidePanel={FunForsetActiveSidePanel}
                                laststatus={""}
                            />
                        )}
                        {activeRightSidePanel === "costSummary" && (
                            <WorkflowCostSummaryModel
                                activeRightSidePinnedPanel={activeRightSidePinnedPanel}
                                FnForsetActiveRightSidePanel={setActiveRightSidePanel}
                                FnForsetActiveRightSidePinnedPanel={
                                    FnForsetActiveRightSidePinnedPanel
                                }
                                nodes={nodes}
                                WorkFlowMachineStatus={WorkFlowMachineStatus}
                            />
                        )}
                        {activeRightSidePanel === "machine" && (
                            <WorkFlowMachineSetupModel
                                selectedNode={selectedNode}
                                FnForSetTrackState={FnForSetTrackState}
                                activeRightSidePinnedPanel={activeRightSidePinnedPanel}
                                NewMachineInfo={NewMachineInfo}
                                activeTab={activeTab}
                                state={state}
                                FnForsetActiveRightSidePanel={setActiveRightSidePanel}
                                FnForsetActiveRightSidePinnedPanel={
                                    FnForsetActiveRightSidePinnedPanel
                                }
                                nodes={nodes}
                                FnForSetNodes={FnForSetNodes}
                                FnForsetSelectedNode={FnForsetSelectedNode}
                                ProjectTermList={ProjectTermList}
                                allMachineList={allMachineList}
                                parametersforworkflow={parametersforworkflow}
                                loop_sample_data={loop_sample_data}
                                edges={edges}
                            />
                        )}
                    </div>



                    <div
                        className="workflow-content"
                        style={{
                            left: `${leftOffset}px`,
                            right: `${rightOffset}px`,
                        }}
                    >
                        <div
                            className="flow-area"
                            onClick={() => {
                                setActiveRightSidePanel(activeRightSidePinnedPanel);
                                setActiveSidePanel(activeSidePanelPinned);

                            }}
                        >
                            <div
                                className={"canvas-workflow-wrapper-close"}
                                id={"canvas-workflow-wrapper"}
                            >
                                <ReactFlow
                                    id={"canvas-workflow-wrapper-ReactFlow"}
                                    defaultZoom={1}
                                    snapToGrid={true}
                                    nodes={nodes}
                                    edges={edges}
                                    onNodesChange={handleWorkflowNodesChange}
                                    onEdgesChange={(edge) => {
                                        onEdgesChange(edge);
                                    }}
                                    onConnect={onConnect}
                                    onDrop={onDrop}
                                    onDragOver={onDragOver}
                                    onConnectStart={onConnectStart}
                                    onConnectEnd={onConnectEnd}
                                    onNodeClick={(event, node) =>
                                        handleNodeClick(
                                            event,
                                            node,
                                            IsWorkFlowIsRunning,
                                            WorkFlowMachineStatus,
                                            WorkFlowMachineUse
                                        )
                                    }
                                    onEdgeClick={(Event, Edge) => handleEdgeClick(Event, Edge)}
                                    onNodeMouseEnter={handleNodeMouseEnter}
                                    onNodeMouseLeave={handleNodeMouseLeave}
                                    onEdgeMouseEnter={handleEdgeMouseEnter}
                                    onEdgeMouseLeave={handleEdgeMouseLeave}
                                    edgeTypes={edgeTypes}
                                    style={{ backgroundColor: "#FFFFFF" }}

                                >
                                    <Background color="gray" gap={30} variant={"dotted"} />
                                    <Controls />
                                    <MiniMap nodeClassName={(node) => node.className} className={`${getWorkflowPopup ? "minimapflowrunningstatus" : ""}`} />
                                </ReactFlow>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {supportShowModel && (
                <SupportModel
                    relatedToLabel={flowName ? flowName.trim() : flowName}
                    case_Type={"Data Factory"}
                    user_Type={Userdata?.associationtype}
                    ass_Id={id}
                    ass_Type={"Workflow"}
                    show={supportShowModel}
                    onHide={() => setSupportShowModel(false)}
                />
            )}

            {IsOpenDataProfileConfiguration && (
                <DataMapping
                    data={DataProfileDetails}
                    show={IsOpenDataProfileConfiguration}
                    onHide={() => setIsOpenDataProfileConfiguration(false)}
                    fnSetDataProfiling={fnSetDataProfiling}
                    fnSetCondition={fnSetCondition}
                    conditionStartIndex={
                        (() => {
                            let count = 0;
                            for (let i = 0; i < nodes.length; i++) {
                                if (nodes[i].id === DataProfileDetails?.nodeid) break;
                                count += (nodes[i].condition_list?.length || 0);
                            }
                            return count;
                        })()
                    }
                />
            )}

            {MachineOutputPopupData.IsOpen && (
                <MachineOutputView
                    jsondata={MachineOutputPopupData.JsonData}
                    show={MachineOutputPopupData.IsOpen}
                    onHide={() => setMachineOutputPopupData({
                        IsOpen: false,
                        JsonData: null,
                        MachineName: ""
                    })}
                    machinename={MachineOutputPopupData.MachineName}
                />
            )}
            {MachineLogPopupData.IsOpen && (
                <SandboxWorkFlowMachineLogDetailModal
                    show={MachineLogPopupData.IsOpen}
                    machineulogid={MachineLogPopupData.MachineULogID}
                    onHide={() => setMachineLogPopupData({
                        IsOpen: false,
                        MachineULogID: ""
                    })}
                />
            )}


            {
                ConvertWorkflowConfirmation &&
                <Modal
                    onHide={(e) => ConvertWorkflowConfirmationClose()}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className={"delete-modal"}
                    backdrop="static"
                    show={ConvertWorkflowConfirmation}
                >
                    <Modal.Body>
                        <div className="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" className="modal-regenerate-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" ><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" /><path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" /></svg>
                            <div className="mb-3 font-size-13">
                                Please select the option for how you would like to proceed with the process.
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <Form.Check
                                    id={"NewWorkflow"}
                                    type="radio"
                                    label="New Workflow"
                                    name="SandboxConvertType"
                                    value="New Workflow"
                                    checked={SandboxConvertType === "New Workflow"}
                                    onChange={(e) => setSandboxConvertType("New Workflow")}
                                />

                                <Form.Check
                                    id={"InExistingWorkflow"}
                                    type="radio"
                                    label="In Existing Workflow"
                                    name="SandboxConvertType"
                                    value="In Existing Workflow"
                                    checked={SandboxConvertType === "In Existing Workflow"}
                                    onChange={(e) => setSandboxConvertType("In Existing Workflow")}
                                />
                            </div>
                            <div className="mb-3">
                                {
                                    SandboxConvertType === "New Workflow" ?
                                        <>
                                            <Form.Group className="form-group mb16">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter Workflow Name"
                                                    className="common-input mt-3"
                                                    maxLength={67}
                                                    value={SandboxConvertWorkflowName}
                                                    onChange={(e) =>
                                                        setSandboxConvertWorkflowName(e.target.value)
                                                    }
                                                    isInvalid={SandboxConvertValidationMessage}
                                                />
                                                {SandboxConvertValidationMessage && (
                                                    <Form.Control.Feedback type="invalid" className="text-start">
                                                        {SandboxConvertValidationMessage}
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>
                                        </>
                                        :
                                        <>
                                            <Form.Group className="form-group mb16">
                                                <div className="position-relative">
                                                    <Form.Select className="common-select mt-3" value={SandboxConvertWorkflowID}
                                                        onChange={(e) =>
                                                            setSandboxConvertWorkflowID(parseInt(e.target.value))
                                                        }
                                                        isInvalid={SandboxConvertValidationMessage}
                                                    >
                                                        <option value="">Select Workflow</option>
                                                        {WorkflowListData?.length > 0 &&
                                                            WorkflowListData?.map(
                                                                (item_cd, index_cd) => (
                                                                    <option
                                                                        key={index_cd}
                                                                        value={item_cd?.workflowid}
                                                                    >
                                                                        {item_cd?.workflowname}
                                                                    </option>
                                                                )
                                                            )}
                                                    </Form.Select>
                                                    {SandboxConvertValidationMessage && (
                                                        <Form.Control.Feedback type="invalid" className="text-start">
                                                            {SandboxConvertValidationMessage}
                                                        </Form.Control.Feedback>
                                                    )}
                                                </div>

                                            </Form.Group>

                                        </>
                                }
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <button className="grey-btn" onClick={(e) => ConvertWorkflowConfirmationClose()}>
                                    No, Keep
                                </button>
                                <button className="blue-btn" onClick={(e) => fnConvertSandboxToWorkflow()}>
                                    Convert
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            }
        </>
    );
};

export default Sandbox;
